var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 494,
    viewBox: "0 0 452 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4314 13.4315 0 30 0H246.376C254.872 0 262.93 3.55742 268.563 9.91789C306.694 52.9704 455.033 223.381 451.953 265.511C448.419 313.844 141.699 496.866 103.889 493.966C73.551 491.639 25.013 439.731 7.01371 419.306C2.39961 414.07 0 407.337 0 400.358V30Z",
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380.823 253.475C377.22 262.529 372.706 271.01 367.532 278.615C360.37 289.128 351.958 297.956 342.965 304.294C338.016 307.783 334.214 309.589 329.926 310.926C325.307 312.367 320.125 313.261 312.312 315.145C311.148 315.431 309.916 315.735 308.622 316.065C301.695 317.845 292.883 320.414 281.129 324.547C266.059 329.851 254.4 334.851 244.955 339.435C243.193 340.294 241.5 341.136 239.877 341.961C215.466 354.444 206.75 363.559 186.809 367.284C177.659 368.985 167.563 369.298 157.051 368.221C144.09 366.902 130.495 363.499 117.283 358.029C100.91 351.25 85.1105 341.31 71.8458 328.279C58.1818 314.867 47.1829 298.191 40.9672 278.329C35.9496 262.303 34.5346 245.783 35.9322 229.784C36.1406 227.449 36.401 225.131 36.7222 222.822C38.389 210.764 41.627 199.096 46.0717 188.262C58.2773 158.486 79.6241 135.013 102.82 127.139C136.702 115.628 155.861 143.746 207.045 131.723C246.787 122.382 249.799 102.007 281.876 100.028C317.399 97.849 356.168 120.229 375.788 153.477C376.5 154.684 377.177 155.891 377.828 157.115C383.479 167.662 386.995 178.713 388.714 189.877C392.082 211.71 388.584 233.925 380.814 253.466L380.823 253.475Z",
    fill: "url(#paint0_linear_47_2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M380.823 253.475C377.22 262.529 372.706 271.01 367.532 278.615C360.37 289.128 351.958 297.956 342.965 304.294C338.016 307.783 334.214 309.589 329.926 310.926C325.307 312.367 320.125 313.261 312.312 315.145C311.148 315.432 309.916 315.735 308.622 316.065C301.695 317.845 292.883 320.414 281.129 324.547C266.059 329.851 254.4 334.851 244.955 339.435C243.193 340.294 241.5 341.136 239.877 341.961C215.466 354.444 206.75 363.559 186.809 367.284C177.659 368.985 167.563 369.298 157.051 368.221C144.09 366.902 130.495 363.499 117.283 358.03C100.91 351.25 85.1105 341.31 71.8458 328.28C58.1818 314.867 47.1829 298.191 40.9672 278.329C35.9496 262.303 34.5346 245.783 35.9322 229.784C47.7819 218.672 71.9761 200.963 105.103 201.84C153.205 203.107 168.666 261.652 168.666 261.652C168.666 261.652 167.885 225.765 204.579 217.37C241.274 208.975 254.261 261.652 254.261 261.652C254.261 261.652 261.736 208.203 298.856 198.272C335.968 188.349 343.598 258.084 343.598 258.084C343.598 258.084 347.513 201.041 388.714 189.868C392.082 211.701 388.584 233.916 380.814 253.457L380.823 253.475Z",
    fill: "url(#paint1_linear_47_2)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 120.611C99.8152 120.611 100.612 119.814 100.612 118.831C100.612 117.848 99.8152 117.051 98.8324 117.051C97.8495 117.051 97.0527 117.848 97.0527 118.831C97.0527 119.814 97.8495 120.611 98.8324 120.611Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 120.61C114.73 120.61 115.527 119.814 115.527 118.831C115.527 117.848 114.73 117.051 113.747 117.051C112.765 117.051 111.968 117.848 111.968 118.831C111.968 119.814 112.765 120.61 113.747 120.61Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 120.61C129.644 120.61 130.441 119.814 130.441 118.831C130.441 117.848 129.644 117.051 128.661 117.051C127.679 117.051 126.882 117.848 126.882 118.831C126.882 119.814 127.679 120.61 128.661 120.61Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 120.611C144.567 120.611 145.364 119.814 145.364 118.831C145.364 117.848 144.567 117.051 143.584 117.051C142.601 117.051 141.805 117.848 141.805 118.831C141.805 119.814 142.601 120.611 143.584 120.611Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 120.611C159.482 120.611 160.279 119.814 160.279 118.831C160.279 117.848 159.482 117.051 158.499 117.051C157.516 117.051 156.72 117.848 156.72 118.831C156.72 119.814 157.516 120.611 158.499 120.611Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 130.247C99.8152 130.247 100.612 129.45 100.612 128.467C100.612 127.484 99.8152 126.687 98.8324 126.687C97.8495 126.687 97.0527 127.484 97.0527 128.467C97.0527 129.45 97.8495 130.247 98.8324 130.247Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 130.247C114.73 130.247 115.527 129.45 115.527 128.467C115.527 127.484 114.73 126.687 113.747 126.687C112.765 126.687 111.968 127.484 111.968 128.467C111.968 129.45 112.765 130.247 113.747 130.247Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 130.247C129.644 130.247 130.441 129.45 130.441 128.467C130.441 127.484 129.644 126.687 128.661 126.687C127.679 126.687 126.882 127.484 126.882 128.467C126.882 129.45 127.679 130.247 128.661 130.247Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 130.247C144.567 130.247 145.364 129.45 145.364 128.467C145.364 127.484 144.567 126.687 143.584 126.687C142.601 126.687 141.805 127.484 141.805 128.467C141.805 129.45 142.601 130.247 143.584 130.247Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 130.247C159.482 130.247 160.279 129.45 160.279 128.467C160.279 127.484 159.482 126.687 158.499 126.687C157.516 126.687 156.72 127.484 156.72 128.467C156.72 129.45 157.516 130.247 158.499 130.247Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 139.883C99.8152 139.883 100.612 139.086 100.612 138.103C100.612 137.12 99.8152 136.323 98.8324 136.323C97.8495 136.323 97.0527 137.12 97.0527 138.103C97.0527 139.086 97.8495 139.883 98.8324 139.883Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 139.883C114.73 139.883 115.527 139.086 115.527 138.103C115.527 137.12 114.73 136.324 113.747 136.324C112.765 136.324 111.968 137.12 111.968 138.103C111.968 139.086 112.765 139.883 113.747 139.883Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 139.883C129.644 139.883 130.441 139.086 130.441 138.103C130.441 137.12 129.644 136.324 128.661 136.324C127.679 136.324 126.882 137.12 126.882 138.103C126.882 139.086 127.679 139.883 128.661 139.883Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 139.883C144.567 139.883 145.364 139.086 145.364 138.103C145.364 137.12 144.567 136.323 143.584 136.323C142.601 136.323 141.805 137.12 141.805 138.103C141.805 139.086 142.601 139.883 143.584 139.883Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 139.883C159.482 139.883 160.279 139.086 160.279 138.103C160.279 137.12 159.482 136.323 158.499 136.323C157.516 136.323 156.72 137.12 156.72 138.103C156.72 139.086 157.516 139.883 158.499 139.883Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 149.519C99.8152 149.519 100.612 148.722 100.612 147.739C100.612 146.756 99.8152 145.959 98.8324 145.959C97.8495 145.959 97.0527 146.756 97.0527 147.739C97.0527 148.722 97.8495 149.519 98.8324 149.519Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 149.519C114.73 149.519 115.527 148.722 115.527 147.739C115.527 146.756 114.73 145.959 113.747 145.959C112.765 145.959 111.968 146.756 111.968 147.739C111.968 148.722 112.765 149.519 113.747 149.519Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 149.519C129.644 149.519 130.441 148.722 130.441 147.739C130.441 146.756 129.644 145.96 128.661 145.96C127.679 145.96 126.882 146.756 126.882 147.739C126.882 148.722 127.679 149.519 128.661 149.519Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 149.519C144.567 149.519 145.364 148.722 145.364 147.739C145.364 146.756 144.567 145.959 143.584 145.959C142.601 145.959 141.805 146.756 141.805 147.739C141.805 148.722 142.601 149.519 143.584 149.519Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 149.519C159.482 149.519 160.279 148.722 160.279 147.739C160.279 146.756 159.482 145.959 158.499 145.959C157.516 145.959 156.72 146.756 156.72 147.739C156.72 148.722 157.516 149.519 158.499 149.519Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 159.155C99.8152 159.155 100.612 158.358 100.612 157.375C100.612 156.392 99.8152 155.595 98.8324 155.595C97.8495 155.595 97.0527 156.392 97.0527 157.375C97.0527 158.358 97.8495 159.155 98.8324 159.155Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 159.155C114.73 159.155 115.527 158.358 115.527 157.375C115.527 156.392 114.73 155.596 113.747 155.596C112.765 155.596 111.968 156.392 111.968 157.375C111.968 158.358 112.765 159.155 113.747 159.155Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 159.155C129.644 159.155 130.441 158.358 130.441 157.375C130.441 156.392 129.644 155.596 128.661 155.596C127.679 155.596 126.882 156.392 126.882 157.375C126.882 158.358 127.679 159.155 128.661 159.155Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 159.155C144.567 159.155 145.364 158.358 145.364 157.375C145.364 156.392 144.567 155.595 143.584 155.595C142.601 155.595 141.805 156.392 141.805 157.375C141.805 158.358 142.601 159.155 143.584 159.155Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 159.155C159.482 159.155 160.279 158.358 160.279 157.375C160.279 156.392 159.482 155.595 158.499 155.595C157.516 155.595 156.72 156.392 156.72 157.375C156.72 158.358 157.516 159.155 158.499 159.155Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 168.791C99.8152 168.791 100.612 167.994 100.612 167.011C100.612 166.028 99.8152 165.232 98.8324 165.232C97.8495 165.232 97.0527 166.028 97.0527 167.011C97.0527 167.994 97.8495 168.791 98.8324 168.791Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 168.791C114.73 168.791 115.527 167.994 115.527 167.011C115.527 166.029 114.73 165.232 113.747 165.232C112.765 165.232 111.968 166.029 111.968 167.011C111.968 167.994 112.765 168.791 113.747 168.791Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 168.791C129.644 168.791 130.441 167.994 130.441 167.011C130.441 166.028 129.644 165.232 128.661 165.232C127.679 165.232 126.882 166.028 126.882 167.011C126.882 167.994 127.679 168.791 128.661 168.791Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 168.791C144.567 168.791 145.364 167.994 145.364 167.011C145.364 166.028 144.567 165.232 143.584 165.232C142.601 165.232 141.805 166.028 141.805 167.011C141.805 167.994 142.601 168.791 143.584 168.791Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 168.791C159.482 168.791 160.279 167.994 160.279 167.011C160.279 166.028 159.482 165.232 158.499 165.232C157.516 165.232 156.72 166.028 156.72 167.011C156.72 167.994 157.516 168.791 158.499 168.791Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8324 178.427C99.8152 178.427 100.612 177.63 100.612 176.647C100.612 175.664 99.8152 174.867 98.8324 174.867C97.8495 174.867 97.0527 175.664 97.0527 176.647C97.0527 177.63 97.8495 178.427 98.8324 178.427Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.747 178.427C114.73 178.427 115.527 177.63 115.527 176.647C115.527 175.664 114.73 174.867 113.747 174.867C112.765 174.867 111.968 175.664 111.968 176.647C111.968 177.63 112.765 178.427 113.747 178.427Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 178.426C129.644 178.426 130.441 177.63 130.441 176.647C130.441 175.664 129.644 174.867 128.661 174.867C127.679 174.867 126.882 175.664 126.882 176.647C126.882 177.63 127.679 178.426 128.661 178.426Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M143.584 178.427C144.567 178.427 145.364 177.63 145.364 176.647C145.364 175.664 144.567 174.867 143.584 174.867C142.601 174.867 141.805 175.664 141.805 176.647C141.805 177.63 142.601 178.427 143.584 178.427Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M158.499 178.427C159.482 178.427 160.279 177.63 160.279 176.647C160.279 175.664 159.482 174.867 158.499 174.867C157.516 174.867 156.72 175.664 156.72 176.647C156.72 177.63 157.516 178.427 158.499 178.427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M297.072 99.5593C298.054 99.5593 298.851 98.7625 298.851 97.7796C298.851 96.7968 298.054 96 297.072 96C296.089 96 295.292 96.7968 295.292 97.7796C295.292 98.7625 296.089 99.5593 297.072 99.5593Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M311.987 99.5593C312.97 99.5593 313.766 98.7625 313.766 97.7796C313.766 96.7968 312.97 96 311.987 96C311.004 96 310.207 96.7968 310.207 97.7796C310.207 98.7625 311.004 99.5593 311.987 99.5593Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 99.5593C327.883 99.5593 328.679 98.7625 328.679 97.7796C328.679 96.7968 327.883 96 326.9 96C325.917 96 325.12 96.7968 325.12 97.7796C325.12 98.7625 325.917 99.5593 326.9 99.5593Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M341.813 99.5593C342.796 99.5593 343.592 98.7625 343.592 97.7796C343.592 96.7968 342.796 96 341.813 96C340.83 96 340.033 96.7968 340.033 97.7796C340.033 98.7625 340.83 99.5593 341.813 99.5593Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M356.738 99.5593C357.72 99.5593 358.517 98.7625 358.517 97.7796C358.517 96.7968 357.72 96 356.738 96C355.755 96 354.958 96.7968 354.958 97.7796C354.958 98.7625 355.755 99.5593 356.738 99.5593Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M297.072 109.195C298.054 109.195 298.851 108.398 298.851 107.416C298.851 106.433 298.054 105.636 297.072 105.636C296.089 105.636 295.292 106.433 295.292 107.416C295.292 108.398 296.089 109.195 297.072 109.195Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M311.987 109.195C312.97 109.195 313.766 108.398 313.766 107.416C313.766 106.433 312.97 105.636 311.987 105.636C311.004 105.636 310.207 106.433 310.207 107.416C310.207 108.398 311.004 109.195 311.987 109.195Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 109.195C327.883 109.195 328.679 108.398 328.679 107.416C328.679 106.433 327.883 105.636 326.9 105.636C325.917 105.636 325.12 106.433 325.12 107.416C325.12 108.398 325.917 109.195 326.9 109.195Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M341.813 109.195C342.796 109.195 343.592 108.398 343.592 107.416C343.592 106.433 342.796 105.636 341.813 105.636C340.83 105.636 340.033 106.433 340.033 107.416C340.033 108.398 340.83 109.195 341.813 109.195Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M356.738 109.195C357.72 109.195 358.517 108.398 358.517 107.416C358.517 106.433 357.72 105.636 356.738 105.636C355.755 105.636 354.958 106.433 354.958 107.416C354.958 108.398 355.755 109.195 356.738 109.195Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M297.072 118.831C298.054 118.831 298.851 118.035 298.851 117.052C298.851 116.069 298.054 115.272 297.072 115.272C296.089 115.272 295.292 116.069 295.292 117.052C295.292 118.035 296.089 118.831 297.072 118.831Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M311.987 118.831C312.97 118.831 313.766 118.035 313.766 117.052C313.766 116.069 312.97 115.272 311.987 115.272C311.004 115.272 310.207 116.069 310.207 117.052C310.207 118.035 311.004 118.831 311.987 118.831Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 118.831C327.883 118.831 328.679 118.035 328.679 117.052C328.679 116.069 327.883 115.272 326.9 115.272C325.917 115.272 325.12 116.069 325.12 117.052C325.12 118.035 325.917 118.831 326.9 118.831Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M341.813 118.831C342.796 118.831 343.592 118.035 343.592 117.052C343.592 116.069 342.796 115.272 341.813 115.272C340.83 115.272 340.033 116.069 340.033 117.052C340.033 118.035 340.83 118.831 341.813 118.831Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M356.738 118.831C357.72 118.831 358.517 118.035 358.517 117.052C358.517 116.069 357.72 115.272 356.738 115.272C355.755 115.272 354.958 116.069 354.958 117.052C354.958 118.035 355.755 118.831 356.738 118.831Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M298.851 126.688C298.851 127.669 298.053 128.467 297.072 128.467C296.091 128.467 295.292 127.669 295.292 126.688C295.292 125.707 296.091 124.908 297.072 124.908C298.053 124.908 298.851 125.707 298.851 126.688Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M313.766 126.688C313.766 127.669 312.968 128.467 311.987 128.467C311.006 128.467 310.207 127.669 310.207 126.688C310.207 125.707 311.006 124.908 311.987 124.908C312.968 124.908 313.766 125.707 313.766 126.688Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M328.679 126.688C328.679 127.669 327.881 128.467 326.9 128.467C325.919 128.467 325.12 127.669 325.12 126.688C325.12 125.707 325.919 124.908 326.9 124.908C327.881 124.908 328.679 125.707 328.679 126.688Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M343.599 126.688C343.599 127.669 342.801 128.467 341.82 128.467C340.839 128.467 340.04 127.669 340.04 126.688C340.04 125.707 340.839 124.908 341.82 124.908C342.801 124.908 343.599 125.707 343.599 126.688Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M358.517 126.688C358.517 127.669 357.719 128.468 356.738 128.468C355.757 128.468 354.958 127.669 354.958 126.688C354.958 125.707 355.757 124.908 356.738 124.908C357.719 124.908 358.517 125.707 358.517 126.688Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M297.072 138.103C298.054 138.103 298.851 137.307 298.851 136.324C298.851 135.341 298.054 134.544 297.072 134.544C296.089 134.544 295.292 135.341 295.292 136.324C295.292 137.307 296.089 138.103 297.072 138.103Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M311.987 138.103C312.97 138.103 313.766 137.307 313.766 136.324C313.766 135.341 312.97 134.544 311.987 134.544C311.004 134.544 310.207 135.341 310.207 136.324C310.207 137.307 311.004 138.103 311.987 138.103Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 138.103C327.883 138.103 328.679 137.307 328.679 136.324C328.679 135.341 327.883 134.544 326.9 134.544C325.917 134.544 325.12 135.341 325.12 136.324C325.12 137.307 325.917 138.103 326.9 138.103Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M341.813 138.103C342.796 138.103 343.592 137.307 343.592 136.324C343.592 135.341 342.796 134.544 341.813 134.544C340.83 134.544 340.033 135.341 340.033 136.324C340.033 137.307 340.83 138.103 341.813 138.103Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M356.738 138.104C357.72 138.104 358.517 137.307 358.517 136.324C358.517 135.341 357.72 134.544 356.738 134.544C355.755 134.544 354.958 135.341 354.958 136.324C354.958 137.307 355.755 138.104 356.738 138.104Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M297.072 147.739C298.054 147.739 298.851 146.943 298.851 145.96C298.851 144.977 298.054 144.18 297.072 144.18C296.089 144.18 295.292 144.977 295.292 145.96C295.292 146.943 296.089 147.739 297.072 147.739Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M311.987 147.739C312.97 147.739 313.766 146.942 313.766 145.96C313.766 144.977 312.97 144.18 311.987 144.18C311.004 144.18 310.207 144.977 310.207 145.96C310.207 146.942 311.004 147.739 311.987 147.739Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 147.739C327.883 147.739 328.679 146.942 328.679 145.96C328.679 144.977 327.883 144.18 326.9 144.18C325.917 144.18 325.12 144.977 325.12 145.96C325.12 146.942 325.917 147.739 326.9 147.739Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M341.813 147.739C342.796 147.739 343.592 146.942 343.592 145.96C343.592 144.977 342.796 144.18 341.813 144.18C340.83 144.18 340.033 144.977 340.033 145.96C340.033 146.942 340.83 147.739 341.813 147.739Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M356.738 147.739C357.72 147.739 358.517 146.943 358.517 145.96C358.517 144.977 357.72 144.18 356.738 144.18C355.755 144.18 354.958 144.977 354.958 145.96C354.958 146.943 355.755 147.739 356.738 147.739Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M297.072 157.375C298.054 157.375 298.851 156.578 298.851 155.596C298.851 154.613 298.054 153.816 297.072 153.816C296.089 153.816 295.292 154.613 295.292 155.596C295.292 156.578 296.089 157.375 297.072 157.375Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M311.987 157.375C312.97 157.375 313.766 156.578 313.766 155.596C313.766 154.613 312.97 153.816 311.987 153.816C311.004 153.816 310.207 154.613 310.207 155.596C310.207 156.578 311.004 157.375 311.987 157.375Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 157.375C327.883 157.375 328.679 156.578 328.679 155.596C328.679 154.613 327.883 153.816 326.9 153.816C325.917 153.816 325.12 154.613 325.12 155.596C325.12 156.578 325.917 157.375 326.9 157.375Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M341.813 157.375C342.796 157.375 343.592 156.578 343.592 155.596C343.592 154.613 342.796 153.816 341.813 153.816C340.83 153.816 340.033 154.613 340.033 155.596C340.033 156.578 340.83 157.375 341.813 157.375Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M356.738 157.375C357.72 157.375 358.517 156.578 358.517 155.596C358.517 154.613 357.72 153.816 356.738 153.816C355.755 153.816 354.958 154.613 354.958 155.596C354.958 156.578 355.755 157.375 356.738 157.375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 310.127C222.636 310.127 223.432 309.33 223.432 308.347C223.432 307.364 222.636 306.568 221.653 306.568C220.67 306.568 219.873 307.364 219.873 308.347C219.873 309.33 220.67 310.127 221.653 310.127Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 310.127C237.561 310.127 238.358 309.33 238.358 308.347C238.358 307.365 237.561 306.568 236.578 306.568C235.596 306.568 234.799 307.365 234.799 308.347C234.799 309.33 235.596 310.127 236.578 310.127Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 310.127C252.472 310.127 253.269 309.33 253.269 308.347C253.269 307.364 252.472 306.568 251.49 306.568C250.507 306.568 249.71 307.364 249.71 308.347C249.71 309.33 250.507 310.127 251.49 310.127Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 308.347C268.184 309.328 267.386 310.127 266.405 310.127C265.424 310.127 264.625 309.328 264.625 308.347C264.625 307.366 265.424 306.568 266.405 306.568C267.386 306.568 268.184 307.366 268.184 308.347Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 310.127C282.302 310.127 283.098 309.33 283.098 308.347C283.098 307.365 282.302 306.568 281.319 306.568C280.336 306.568 279.539 307.365 279.539 308.347C279.539 309.33 280.336 310.127 281.319 310.127Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 319.763C222.636 319.763 223.432 318.967 223.432 317.984C223.432 317.001 222.636 316.204 221.653 316.204C220.67 316.204 219.873 317.001 219.873 317.984C219.873 318.967 220.67 319.763 221.653 319.763Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 319.763C237.561 319.763 238.358 318.967 238.358 317.984C238.358 317.001 237.561 316.204 236.578 316.204C235.596 316.204 234.799 317.001 234.799 317.984C234.799 318.967 235.596 319.763 236.578 319.763Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 319.763C252.472 319.763 253.269 318.966 253.269 317.984C253.269 317.001 252.472 316.204 251.49 316.204C250.507 316.204 249.71 317.001 249.71 317.984C249.71 318.966 250.507 319.763 251.49 319.763Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 317.984C268.184 318.965 267.386 319.763 266.405 319.763C265.424 319.763 264.625 318.965 264.625 317.984C264.625 317.003 265.424 316.204 266.405 316.204C267.386 316.204 268.184 317.003 268.184 317.984Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 319.763C282.302 319.763 283.098 318.967 283.098 317.984C283.098 317.001 282.302 316.204 281.319 316.204C280.336 316.204 279.539 317.001 279.539 317.984C279.539 318.967 280.336 319.763 281.319 319.763Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 329.4C222.636 329.4 223.432 328.603 223.432 327.62C223.432 326.637 222.636 325.84 221.653 325.84C220.67 325.84 219.873 326.637 219.873 327.62C219.873 328.603 220.67 329.4 221.653 329.4Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 329.4C237.561 329.4 238.358 328.603 238.358 327.62C238.358 326.637 237.561 325.84 236.578 325.84C235.596 325.84 234.799 326.637 234.799 327.62C234.799 328.603 235.596 329.4 236.578 329.4Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 329.399C252.472 329.399 253.269 328.603 253.269 327.62C253.269 326.637 252.472 325.84 251.49 325.84C250.507 325.84 249.71 326.637 249.71 327.62C249.71 328.603 250.507 329.399 251.49 329.399Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 327.62C268.184 328.601 267.386 329.399 266.405 329.399C265.424 329.399 264.625 328.601 264.625 327.62C264.625 326.639 265.424 325.84 266.405 325.84C267.386 325.84 268.184 326.639 268.184 327.62Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 329.4C282.302 329.4 283.098 328.603 283.098 327.62C283.098 326.637 282.302 325.84 281.319 325.84C280.336 325.84 279.539 326.637 279.539 327.62C279.539 328.603 280.336 329.4 281.319 329.4Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 339.036C222.636 339.036 223.432 338.239 223.432 337.256C223.432 336.273 222.636 335.476 221.653 335.476C220.67 335.476 219.873 336.273 219.873 337.256C219.873 338.239 220.67 339.036 221.653 339.036Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 339.036C237.561 339.036 238.358 338.239 238.358 337.256C238.358 336.273 237.561 335.476 236.578 335.476C235.596 335.476 234.799 336.273 234.799 337.256C234.799 338.239 235.596 339.036 236.578 339.036Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 339.035C252.472 339.035 253.269 338.239 253.269 337.256C253.269 336.273 252.472 335.476 251.49 335.476C250.507 335.476 249.71 336.273 249.71 337.256C249.71 338.239 250.507 339.035 251.49 339.035Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 337.256C268.184 338.237 267.386 339.035 266.405 339.035C265.424 339.035 264.625 338.237 264.625 337.256C264.625 336.275 265.424 335.476 266.405 335.476C267.386 335.476 268.184 336.275 268.184 337.256Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 339.036C282.302 339.036 283.098 338.239 283.098 337.256C283.098 336.273 282.302 335.476 281.319 335.476C280.336 335.476 279.539 336.273 279.539 337.256C279.539 338.239 280.336 339.036 281.319 339.036Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 348.671C222.636 348.671 223.432 347.874 223.432 346.891C223.432 345.909 222.636 345.112 221.653 345.112C220.67 345.112 219.873 345.909 219.873 346.891C219.873 347.874 220.67 348.671 221.653 348.671Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 348.671C237.561 348.671 238.358 347.874 238.358 346.892C238.358 345.909 237.561 345.112 236.578 345.112C235.596 345.112 234.799 345.909 234.799 346.892C234.799 347.874 235.596 348.671 236.578 348.671Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 348.671C252.472 348.671 253.269 347.874 253.269 346.891C253.269 345.909 252.472 345.112 251.49 345.112C250.507 345.112 249.71 345.909 249.71 346.891C249.71 347.874 250.507 348.671 251.49 348.671Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 346.892C268.184 347.873 267.386 348.671 266.405 348.671C265.424 348.671 264.625 347.873 264.625 346.892C264.625 345.911 265.424 345.112 266.405 345.112C267.386 345.112 268.184 345.911 268.184 346.892Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 348.671C282.302 348.671 283.098 347.874 283.098 346.891C283.098 345.909 282.302 345.112 281.319 345.112C280.336 345.112 279.539 345.909 279.539 346.891C279.539 347.874 280.336 348.671 281.319 348.671Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 358.307C222.636 358.307 223.432 357.511 223.432 356.528C223.432 355.545 222.636 354.748 221.653 354.748C220.67 354.748 219.873 355.545 219.873 356.528C219.873 357.511 220.67 358.307 221.653 358.307Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 358.307C237.561 358.307 238.358 357.511 238.358 356.528C238.358 355.545 237.561 354.748 236.578 354.748C235.596 354.748 234.799 355.545 234.799 356.528C234.799 357.511 235.596 358.307 236.578 358.307Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 358.307C252.472 358.307 253.269 357.511 253.269 356.528C253.269 355.545 252.472 354.748 251.49 354.748C250.507 354.748 249.71 355.545 249.71 356.528C249.71 357.511 250.507 358.307 251.49 358.307Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 356.528C268.184 357.509 267.386 358.307 266.405 358.307C265.424 358.307 264.625 357.509 264.625 356.528C264.625 355.547 265.424 354.748 266.405 354.748C267.386 354.748 268.184 355.547 268.184 356.528Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 358.307C282.302 358.307 283.098 357.511 283.098 356.528C283.098 355.545 282.302 354.748 281.319 354.748C280.336 354.748 279.539 355.545 279.539 356.528C279.539 357.511 280.336 358.307 281.319 358.307Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M221.653 367.943C222.636 367.943 223.432 367.147 223.432 366.164C223.432 365.181 222.636 364.384 221.653 364.384C220.67 364.384 219.873 365.181 219.873 366.164C219.873 367.147 220.67 367.943 221.653 367.943Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 367.943C237.561 367.943 238.358 367.147 238.358 366.164C238.358 365.181 237.561 364.384 236.578 364.384C235.596 364.384 234.799 365.181 234.799 366.164C234.799 367.147 235.596 367.943 236.578 367.943Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 367.943C252.472 367.943 253.269 367.147 253.269 366.164C253.269 365.181 252.472 364.384 251.49 364.384C250.507 364.384 249.71 365.181 249.71 366.164C249.71 367.147 250.507 367.943 251.49 367.943Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M268.184 366.164C268.184 367.145 267.386 367.943 266.405 367.943C265.424 367.943 264.625 367.145 264.625 366.164C264.625 365.183 265.424 364.384 266.405 364.384C267.386 364.384 268.184 365.183 268.184 366.164Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M281.319 367.943C282.302 367.943 283.098 367.147 283.098 366.164C283.098 365.181 282.302 364.384 281.319 364.384C280.336 364.384 279.539 365.181 279.539 366.164C279.539 367.147 280.336 367.943 281.319 367.943Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 185,
    width: 98,
    height: 116
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9458 300.24C46.6035 293.963 43.7735 287.261 41.5511 280.169C31.9846 249.603 35.5178 217.24 46.647 190.102L89.4708 185.467L132.329 195.988C142.287 257.433 78.9493 289.102 49.9545 300.24H49.9458Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_2)"
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0364 270.776C70.1819 273.693 68.793 264.968 68.793 264.968C68.793 264.968 78.8891 267.095 74.0364 270.776Z",
    fill: "url(#paint2_linear_47_2)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0775 250.531C85.2962 244.498 93.8992 250.202 93.8992 250.202C93.8992 250.202 86.7026 255.323 86.0775 250.531Z",
    fill: "url(#paint3_linear_47_2)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4481 301.194C43.5263 301.142 50.5406 296.637 58.9265 288.694C58.779 288.772 58.6053 288.85 58.4317 288.919C53.9523 290.734 54.8811 281.94 54.8811 281.94C54.8811 281.94 61.0621 285.1 60.1679 287.496C61.2791 286.41 62.4077 285.282 63.5449 284.084C64.5432 283.042 65.5589 281.922 66.592 280.75C66.5486 280.785 66.5051 280.811 66.4531 280.846C62.3903 283.459 61.6611 274.656 61.6611 274.656C61.6611 274.656 68.606 276.688 67.8594 279.283C72.226 274.153 76.7228 267.928 80.3776 260.836C77.5128 263.918 74.0056 256.374 74.0056 256.374C74.0056 256.374 81.5148 255.853 81.428 258.726C82.652 256.174 83.7545 253.518 84.7007 250.766C81.8533 253.648 78.3983 246.234 78.3983 246.234C78.3983 246.234 84.5011 245.809 85.6383 247.832C86.2981 245.583 86.8537 243.265 87.279 240.904C83.9628 240.47 86.0984 233.343 86.0984 233.343C86.0984 233.343 94.2673 239.654 88.3034 240.852C88.1992 240.869 88.1037 240.887 88.0082 240.895C86.9318 247.016 84.9785 252.771 82.5218 258.084C84.5619 257.025 89.5188 260.306 89.5188 260.306C89.5188 260.306 82.3221 265.428 81.6971 260.636C81.6624 260.358 81.6537 260.115 81.6537 259.881C80.0824 263.076 78.3288 266.097 76.4884 268.935C78.7455 268.458 82.626 272.989 82.626 272.989C82.626 272.989 74.3008 275.95 75.0126 271.166C75.0126 271.149 75.0126 271.14 75.0126 271.123C72.9899 274.057 70.8891 276.774 68.8143 279.24C71.0888 278.571 74.839 283.711 74.839 283.711C74.839 283.711 66.3142 286.02 67.3906 281.315C67.4427 281.089 67.5035 280.889 67.5642 280.698C66.3749 282.07 65.1943 283.355 64.0571 284.553C62.9719 285.69 61.8955 286.784 60.8277 287.817C63.2237 287.209 66.1145 293.295 66.1145 293.295C66.1145 293.295 57.3032 293.972 59.2477 289.544C59.3085 289.405 59.378 289.267 59.4387 289.145C50.9833 297.158 43.8996 301.707 43.8214 301.759L43.4395 301.16L43.4481 301.194Z",
    fill: "url(#paint4_linear_47_2)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4536 273.259C45.9591 264.57 43.9191 246.14 52.0272 231.13C58.1474 219.793 46.1414 213.559 37.3301 224.645C28.5188 235.731 36.9221 258.693 33.9792 267.426C31.0363 276.168 37.8076 280.3 41.4536 273.259Z",
    fill: "url(#paint5_linear_47_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4185 219.55C50.4185 219.55 43.9858 222.588 41.1471 230.349C38.3084 238.11 40.5308 267.73 34.6797 275.768",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8672 225.252L40.4264 233.343C40.4264 233.343 50.7135 229.732 52.4845 230.201",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2549 237.432C33.2549 237.432 37.8211 242.702 39.4619 244.733C39.4619 244.733 45.2695 242.146 47.544 242.971",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6982 249.777C33.6982 249.777 37.4658 252.711 38.9416 254.699C38.9416 254.699 42.77 251.765 45.6 253.111",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.542 259.178C34.542 259.178 37.5196 261.244 38.2054 263.241C38.2054 263.241 42.5026 259.516 44.5687 260.584",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6745 279.631C52.8408 287.436 46.2692 294.45 39.2983 300.44C38.6819 282.722 41.8158 279.423 42.9096 271.158C44.0382 262.634 45.0452 266.774 48.9951 266.427C52.945 266.089 47.6061 262.425 48.0228 256.974C48.4395 251.522 53.1012 244.013 53.3964 237.05C53.6916 230.088 57.0425 231.33 57.8759 232.18C58.7006 233.022 60.784 232.788 60.758 229.619C60.7319 226.451 56.6431 227.275 56.973 224.116C57.3029 220.956 64.6211 205.434 63.1627 196.076C71.3837 197.768 71.2621 219.706 71.4792 229.958C71.7049 240.21 63.0932 240.176 63.0498 242.971C62.9977 245.766 69.1526 241.834 69.7516 242.858C70.3506 243.882 64.2999 266.323 59.9246 271.48C55.5493 276.619 51.9727 276.185 52.1724 278.702C52.372 281.22 58.0148 276.61 58.0148 278.546C58.0148 278.911 58.2839 279.241 58.6658 279.623L58.6745 279.631Z",
    fill: "url(#paint6_linear_47_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M63.161 196.084C63.161 196.084 69.2465 198.958 66.5467 219.497C63.8468 240.037 56.8672 252.034 55.1397 261.765C53.4208 271.497 45.3908 288.668 46.5194 293.712",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 286,
    y: 156,
    width: 105,
    height: 155
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M380.828 253.474C377.225 262.529 372.711 271.01 367.537 278.615C360.384 289.128 351.963 297.956 342.969 304.294C338.021 307.783 334.219 309.589 329.93 310.926C320.616 299.38 286.646 257.207 286.212 255.141C285.7 252.754 316.24 183.739 316.24 183.739L351.807 201.596L355.661 163.417L376.097 156.116L377.833 157.132C394.544 188.305 392.565 223.95 380.819 253.483L380.828 253.474Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_47_2)"
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M348.452 254.212C350.718 258.483 355.658 251.156 355.658 251.156C355.658 251.156 345.605 248.838 348.452 254.212Z",
    fill: "url(#paint7_linear_47_2)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M346.06 230.782C349.307 225.634 339.106 227.188 339.106 227.188C339.106 227.188 343.482 234.862 346.06 230.782Z",
    fill: "url(#paint8_linear_47_2)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M363.404 294.692C363.352 294.606 358.89 287.574 354.628 276.835C354.732 276.974 354.853 277.105 354.984 277.252C358.282 280.777 361.139 272.417 361.139 272.417C361.139 272.417 354.202 272.677 354.003 275.229C353.447 273.78 352.9 272.278 352.379 270.715C351.919 269.352 351.459 267.911 351.016 266.409C351.042 266.453 351.068 266.505 351.103 266.548C353.69 270.628 358.057 262.954 358.057 262.954C358.057 262.954 350.895 261.869 350.487 264.543C348.69 258.049 347.231 250.514 346.902 242.536C348.204 246.538 354.558 241.173 354.558 241.173C354.558 241.173 347.969 237.545 346.832 240.184C346.797 237.354 346.91 234.48 347.214 231.589C348.586 235.409 354.836 230.14 354.836 230.14C354.836 230.14 349.48 227.188 347.596 228.542C347.943 226.225 348.412 223.889 349.028 221.571C352.214 222.578 353.282 215.217 353.282 215.217C353.282 215.217 343.221 217.5 348.126 221.103C348.212 221.163 348.291 221.216 348.377 221.268C346.78 227.275 346.12 233.317 346.112 239.168C344.705 237.345 338.828 238.239 338.828 238.239C338.828 238.239 343.203 245.913 345.782 241.833C345.929 241.599 346.042 241.373 346.138 241.165C346.224 244.724 346.537 248.205 347.014 251.547C345.174 250.167 339.74 252.641 339.74 252.641C339.74 252.641 346.042 258.831 347.414 254.195C347.414 254.178 347.414 254.169 347.422 254.152C348.021 257.668 348.785 261.01 349.627 264.126C347.848 262.564 342.283 265.645 342.283 265.645C342.283 265.645 349.046 271.332 350.053 266.609C350.105 266.383 350.131 266.175 350.148 265.975C350.652 267.72 351.181 269.387 351.711 270.95C352.214 272.443 352.735 273.884 353.265 275.273C351.346 273.71 346.155 278.016 346.155 278.016C346.155 278.016 353.855 282.339 353.968 277.513C353.968 277.356 353.968 277.209 353.968 277.07C358.265 287.895 362.771 295.005 362.823 295.092L363.422 294.71L363.404 294.692Z",
    fill: "url(#paint9_linear_47_2)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M361.73 302.306C358.024 293.243 342.667 282.86 336.477 266.965C331.807 254.959 319.28 260.072 322.023 273.962C324.766 287.852 347.702 296.325 352.45 304.224C357.199 312.124 364.734 309.65 361.73 302.306Z",
    fill: "url(#paint10_linear_47_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M326.624 260.689C326.624 260.689 324.775 267.555 328.846 274.743C332.918 281.931 356.93 299.424 359.265 309.086",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M322.196 274.709L330.66 277.235C330.66 277.235 334.567 267.061 336.077 266.01",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M329.135 285.352C329.135 285.352 336.106 285.291 338.71 285.352C338.71 285.352 340.498 279.249 342.599 278.051",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M338.831 293.008C338.831 293.008 343.51 292.045 345.976 292.21C345.976 292.21 346.219 287.392 349.075 286.107",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M346.531 298.452C346.531 298.452 350.038 297.523 352 298.295C352 298.295 351.948 292.609 354.101 291.724",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M380.828 253.475C377.226 262.53 372.711 271.011 367.537 278.616C362.32 261.67 364.499 257.668 363.397 249.404C362.268 240.879 364.317 244.612 368.041 243.249C371.765 241.895 365.662 239.75 364.638 234.368C363.622 228.994 366.166 220.53 364.638 213.733C363.11 206.936 366.669 207.266 367.694 207.865C368.709 208.464 370.663 207.691 369.812 204.644C368.961 201.588 365.228 203.455 364.725 200.321C364.213 197.178 367.242 180.293 363.397 171.638C371.774 171.126 377.364 192.343 380.255 202.187C383.137 212.023 374.821 214.237 375.507 216.954C376.184 219.662 381.106 214.271 381.948 215.096C382.799 215.929 382.799 239.177 379.917 245.289C377.035 251.392 373.467 251.904 374.317 254.282C375.168 256.661 379.413 250.741 379.917 252.607C380.012 252.954 380.359 253.206 380.82 253.475H380.828Z",
    fill: "url(#paint11_linear_47_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M363.404 171.639C363.404 171.639 370.028 172.828 372.771 193.359C375.514 213.889 371.894 227.293 372.771 237.137C373.648 246.982 370.375 265.655 372.771 270.23",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 117,
    width: 145,
    height: 223
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M311.028 257.946C307.842 266.566 309.187 293.894 310.793 315.145C309.63 315.432 308.397 315.736 307.104 316.066C300.176 317.845 291.365 320.415 279.611 324.547C264.54 329.851 252.882 334.851 243.437 339.435C241.692 314.677 237.985 283.676 233.705 278.841C224.086 267.99 211.212 241.851 201.055 224.645C190.89 207.439 175.108 195.008 178.163 177.697C181.21 160.387 204.12 174.642 222.741 178.713C234.478 181.283 237.368 189.92 237.516 195.068C241.874 189.365 255.781 180.371 272.049 184.694C292.632 190.163 255.026 149.189 253.915 128.319C252.795 107.45 279.463 119.161 299.161 134.431C318.858 149.701 300.333 155.812 314.587 178.21C328.841 200.607 318.658 237.258 311.019 257.937L311.028 257.946Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_47_2)"
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M224.762 200.745C221.02 199.313 216.245 200.155 213.815 201.127C212.165 197.49 208.259 195.285 204.882 194.174C201.271 192.993 199.786 191.274 199.786 189.026C199.786 186.777 205.95 190.449 209.917 191.161C211.757 191.491 214.744 191.161 217.591 191.943C219.492 192.463 221.341 193.479 222.748 195.537C223.624 196.821 224.336 198.514 224.77 200.754L224.762 200.745Z",
    fill: "url(#paint12_linear_47_2)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M291.189 336.63C283.741 339.347 274.964 340.884 267.038 339.104C267.221 334.66 267.169 329.555 266.978 324.156C266.196 302.774 263.062 276.583 262.385 266.956C261.864 259.646 262.411 254.707 263.106 251.573C263.826 248.3 264.712 246.989 264.712 246.989C265.172 246.85 265.641 246.703 266.11 246.529C271.162 244.723 275.598 242.57 279.444 240.14C279.444 240.14 280.086 240.791 280.972 242.197C281.666 243.3 282.517 244.88 283.315 246.989C284.062 248.934 284.765 251.33 285.277 254.212C285.573 255.887 285.807 257.728 285.946 259.733C286.805 272.477 292.717 316.716 291.181 336.639L291.189 336.63Z",
    fill: "url(#paint13_linear_47_2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 262,
    y: 240,
    width: 30,
    height: 100
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M291.187 336.63C283.739 339.347 274.962 340.884 267.036 339.104C267.939 317.072 263.234 279.014 262.383 266.956C261.862 259.646 262.409 254.707 263.104 251.573C263.824 248.3 264.71 246.989 264.71 246.989C265.17 246.85 265.639 246.703 266.108 246.529C271.16 244.723 275.596 242.57 279.442 240.14C279.442 240.14 280.084 240.791 280.97 242.197C282.688 244.923 285.319 250.505 285.944 259.733C286.803 272.477 292.715 316.716 291.179 336.639L291.187 336.63Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_47_2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M274.464 262.19C274.464 262.754 274.004 263.214 273.439 263.214C272.875 263.214 272.415 262.754 272.415 262.19C272.415 261.625 272.875 261.165 273.439 261.165C274.004 261.165 274.464 261.625 274.464 262.19Z",
    fill: "url(#paint14_linear_47_2)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M279.863 263.214C280.429 263.214 280.888 262.755 280.888 262.19C280.888 261.624 280.429 261.165 279.863 261.165C279.297 261.165 278.839 261.624 278.839 262.19C278.839 262.755 279.297 263.214 279.863 263.214Z",
    fill: "url(#paint15_linear_47_2)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M286.292 263.214C286.858 263.214 287.316 262.755 287.316 262.19C287.316 261.624 286.858 261.165 286.292 261.165C285.726 261.165 285.268 261.624 285.268 262.19C285.268 262.755 285.726 263.214 286.292 263.214Z",
    fill: "url(#paint16_linear_47_2)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M274.464 267.546C274.464 268.11 274.004 268.57 273.439 268.57C272.875 268.57 272.415 268.11 272.415 267.546C272.415 266.982 272.875 266.522 273.439 266.522C274.004 266.522 274.464 266.982 274.464 267.546Z",
    fill: "url(#paint17_linear_47_2)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M279.863 268.57C280.429 268.57 280.888 268.112 280.888 267.546C280.888 266.98 280.429 266.522 279.863 266.522C279.297 266.522 278.839 266.98 278.839 267.546C278.839 268.112 279.297 268.57 279.863 268.57Z",
    fill: "url(#paint18_linear_47_2)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M286.292 268.57C286.858 268.57 287.316 268.112 287.316 267.546C287.316 266.98 286.858 266.522 286.292 266.522C285.726 266.522 285.268 266.98 285.268 267.546C285.268 268.112 285.726 268.57 286.292 268.57Z",
    fill: "url(#paint19_linear_47_2)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M274.464 272.902C274.464 273.467 274.004 273.927 273.439 273.927C272.875 273.927 272.415 273.467 272.415 272.902C272.415 272.338 272.875 271.878 273.439 271.878C274.004 271.878 274.464 272.338 274.464 272.902Z",
    fill: "url(#paint20_linear_47_2)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M279.863 273.927C280.429 273.927 280.888 273.468 280.888 272.902C280.888 272.337 280.429 271.878 279.863 271.878C279.297 271.878 278.839 272.337 278.839 272.902C278.839 273.468 279.297 273.927 279.863 273.927Z",
    fill: "url(#paint21_linear_47_2)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M286.292 273.927C286.858 273.927 287.316 273.468 287.316 272.902C287.316 272.337 286.858 271.878 286.292 271.878C285.726 271.878 285.268 272.337 285.268 272.902C285.268 273.468 285.726 273.927 286.292 273.927Z",
    fill: "url(#paint22_linear_47_2)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M274.464 278.259C274.464 278.823 274.004 279.283 273.439 279.283C272.875 279.283 272.415 278.823 272.415 278.259C272.415 277.694 272.875 277.234 273.439 277.234C274.004 277.234 274.464 277.694 274.464 278.259Z",
    fill: "url(#paint23_linear_47_2)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M279.863 279.283C280.429 279.283 280.888 278.825 280.888 278.259C280.888 277.693 280.429 277.234 279.863 277.234C279.297 277.234 278.839 277.693 278.839 278.259C278.839 278.825 279.297 279.283 279.863 279.283Z",
    fill: "url(#paint24_linear_47_2)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M286.292 279.283C286.858 279.283 287.316 278.824 287.316 278.259C287.316 277.693 286.858 277.234 286.292 277.234C285.726 277.234 285.268 277.693 285.268 278.259C285.268 278.824 285.726 279.283 286.292 279.283Z",
    fill: "url(#paint25_linear_47_2)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M274.464 283.615C274.464 284.179 274.004 284.639 273.439 284.639C272.875 284.639 272.415 284.179 272.415 283.615C272.415 283.05 272.875 282.59 273.439 282.59C274.004 282.59 274.464 283.05 274.464 283.615Z",
    fill: "url(#paint26_linear_47_2)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M279.863 284.639C280.429 284.639 280.888 284.18 280.888 283.615C280.888 283.049 280.429 282.59 279.863 282.59C279.297 282.59 278.839 283.049 278.839 283.615C278.839 284.18 279.297 284.639 279.863 284.639Z",
    fill: "url(#paint27_linear_47_2)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M286.292 284.639C286.858 284.639 287.316 284.181 287.316 283.615C287.316 283.049 286.858 282.59 286.292 282.59C285.726 282.59 285.268 283.049 285.268 283.615C285.268 284.181 285.726 284.639 286.292 284.639Z",
    fill: "url(#paint28_linear_47_2)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M274.464 288.98C274.464 289.544 274.004 290.004 273.439 290.004C272.875 290.004 272.415 289.544 272.415 288.98C272.415 288.415 272.875 287.955 273.439 287.955C274.004 287.955 274.464 288.415 274.464 288.98Z",
    fill: "url(#paint29_linear_47_2)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M280.888 288.98C280.888 289.544 280.428 290.004 279.863 290.004C279.299 290.004 278.839 289.544 278.839 288.98C278.839 288.415 279.299 287.955 279.863 287.955C280.428 287.955 280.888 288.415 280.888 288.98Z",
    fill: "url(#paint30_linear_47_2)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M287.316 288.98C287.316 289.544 286.856 290.004 286.292 290.004C285.728 290.004 285.268 289.544 285.268 288.98C285.268 288.415 285.728 287.955 286.292 287.955C286.856 287.955 287.316 288.415 287.316 288.98Z",
    fill: "url(#paint31_linear_47_2)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M266.755 301.68C267.321 301.68 267.779 301.221 267.779 300.656C267.779 300.09 267.321 299.631 266.755 299.631C266.189 299.631 265.73 300.09 265.73 300.656C265.73 301.221 266.189 301.68 266.755 301.68Z",
    fill: "url(#paint32_linear_47_2)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M273.18 301.68C273.745 301.68 274.204 301.221 274.204 300.656C274.204 300.09 273.745 299.631 273.18 299.631C272.614 299.631 272.155 300.09 272.155 300.656C272.155 301.221 272.614 301.68 273.18 301.68Z",
    fill: "url(#paint33_linear_47_2)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61 301.68C280.176 301.68 280.635 301.221 280.635 300.656C280.635 300.09 280.176 299.631 279.61 299.631C279.045 299.631 278.586 300.09 278.586 300.656C278.586 301.221 279.045 301.68 279.61 301.68Z",
    fill: "url(#paint34_linear_47_2)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M266.755 307.036C267.321 307.036 267.779 306.578 267.779 306.012C267.779 305.446 267.321 304.987 266.755 304.987C266.189 304.987 265.73 305.446 265.73 306.012C265.73 306.578 266.189 307.036 266.755 307.036Z",
    fill: "url(#paint35_linear_47_2)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M273.18 307.036C273.745 307.036 274.204 306.578 274.204 306.012C274.204 305.446 273.745 304.987 273.18 304.987C272.614 304.987 272.155 305.446 272.155 306.012C272.155 306.578 272.614 307.036 273.18 307.036Z",
    fill: "url(#paint36_linear_47_2)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61 307.036C280.176 307.036 280.635 306.577 280.635 306.012C280.635 305.446 280.176 304.987 279.61 304.987C279.045 304.987 278.586 305.446 278.586 306.012C278.586 306.577 279.045 307.036 279.61 307.036Z",
    fill: "url(#paint37_linear_47_2)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M266.755 312.393C267.321 312.393 267.779 311.934 267.779 311.368C267.779 310.803 267.321 310.344 266.755 310.344C266.189 310.344 265.73 310.803 265.73 311.368C265.73 311.934 266.189 312.393 266.755 312.393Z",
    fill: "url(#paint38_linear_47_2)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M273.18 312.393C273.745 312.393 274.204 311.934 274.204 311.368C274.204 310.803 273.745 310.344 273.18 310.344C272.614 310.344 272.155 310.803 272.155 311.368C272.155 311.934 272.614 312.393 273.18 312.393Z",
    fill: "url(#paint39_linear_47_2)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61 312.392C280.176 312.392 280.635 311.934 280.635 311.368C280.635 310.802 280.176 310.344 279.61 310.344C279.045 310.344 278.586 310.802 278.586 311.368C278.586 311.934 279.045 312.392 279.61 312.392Z",
    fill: "url(#paint40_linear_47_2)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M266.755 317.748C267.321 317.748 267.779 317.29 267.779 316.724C267.779 316.158 267.321 315.7 266.755 315.7C266.189 315.7 265.73 316.158 265.73 316.724C265.73 317.29 266.189 317.748 266.755 317.748Z",
    fill: "url(#paint41_linear_47_2)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M273.18 317.748C273.745 317.748 274.204 317.29 274.204 316.724C274.204 316.158 273.745 315.7 273.18 315.7C272.614 315.7 272.155 316.158 272.155 316.724C272.155 317.29 272.614 317.748 273.18 317.748Z",
    fill: "url(#paint42_linear_47_2)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61 317.748C280.176 317.748 280.635 317.29 280.635 316.724C280.635 316.158 280.176 315.7 279.61 315.7C279.045 315.7 278.586 316.158 278.586 316.724C278.586 317.29 279.045 317.748 279.61 317.748Z",
    fill: "url(#paint43_linear_47_2)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M266.755 323.113C267.321 323.113 267.779 322.655 267.779 322.089C267.779 321.523 267.321 321.064 266.755 321.064C266.189 321.064 265.73 321.523 265.73 322.089C265.73 322.655 266.189 323.113 266.755 323.113Z",
    fill: "url(#paint44_linear_47_2)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M273.18 323.113C273.745 323.113 274.204 322.655 274.204 322.089C274.204 321.523 273.745 321.064 273.18 321.064C272.614 321.064 272.155 321.523 272.155 322.089C272.155 322.655 272.614 323.113 273.18 323.113Z",
    fill: "url(#paint45_linear_47_2)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61 323.113C280.176 323.113 280.635 322.655 280.635 322.089C280.635 321.523 280.176 321.064 279.61 321.064C279.045 321.064 278.586 321.523 278.586 322.089C278.586 322.655 279.045 323.113 279.61 323.113Z",
    fill: "url(#paint46_linear_47_2)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M266.755 328.47C267.321 328.47 267.779 328.011 267.779 327.446C267.779 326.88 267.321 326.421 266.755 326.421C266.189 326.421 265.73 326.88 265.73 327.446C265.73 328.011 266.189 328.47 266.755 328.47Z",
    fill: "url(#paint47_linear_47_2)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M273.18 328.47C273.745 328.47 274.204 328.011 274.204 327.446C274.204 326.88 273.745 326.421 273.18 326.421C272.614 326.421 272.155 326.88 272.155 327.446C272.155 328.011 272.614 328.47 273.18 328.47Z",
    fill: "url(#paint48_linear_47_2)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61 328.47C280.176 328.47 280.635 328.011 280.635 327.445C280.635 326.88 280.176 326.421 279.61 326.421C279.045 326.421 278.586 326.88 278.586 327.445C278.586 328.011 279.045 328.47 279.61 328.47Z",
    fill: "url(#paint49_linear_47_2)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M273.307 256.209C267.681 256.13 264.686 253.934 263.106 251.564C263.827 248.291 264.712 246.981 264.712 246.981C265.173 246.842 265.641 246.694 266.11 246.521C271.163 244.715 275.599 242.562 279.444 240.131C279.444 240.131 280.087 240.782 280.972 242.189C281.189 249.003 279.887 256.295 273.307 256.209Z",
    fill: "url(#paint50_linear_47_2)"
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M276.808 235.617C276.582 235.999 276.348 236.364 276.105 236.711C272.919 241.355 268.691 243.283 264.715 243.343C262.91 243.378 261.156 243.022 259.576 242.362C250.99 238.786 254.246 226.693 256.034 221.667C256.52 220.295 256.902 219.444 256.902 219.444C263.3 222.908 275.028 220.156 275.471 220.425C275.888 220.668 277.537 227.57 277.754 228.49C277.772 228.559 277.78 228.594 277.78 228.594C277.78 228.594 278.9 228.108 280.072 228.403C280.706 228.559 281.366 228.941 281.869 229.757C283.293 232.067 281.513 238.109 276.808 235.617Z",
    fill: "url(#paint51_linear_47_2)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M280.074 228.403C278.894 228.117 277.783 228.594 277.783 228.594C277.783 228.594 275.916 220.686 275.473 220.425C275.031 220.156 263.302 222.917 256.904 219.444C249.091 216.684 245.359 206.032 251.67 198.566C257.972 191.101 267.921 205.407 273.963 207.265C280.005 209.131 286.307 206.64 288.182 215.078C289.589 221.458 283.59 224.592 280.074 228.386V228.403Z",
    fill: "#CE4D34"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M277.249 246.868C276.554 248.231 275.53 249.646 274.201 250.618C271.267 252.745 265.052 250.974 265.138 247.684C265.156 246.989 265.112 246.217 265.026 245.427C264.947 244.732 264.843 244.02 264.722 243.343C268.698 243.283 272.925 241.347 276.111 236.711C276.658 239.906 278.108 242.293 278.29 243.057C278.438 243.682 278.082 245.236 277.257 246.859L277.249 246.868Z",
    fill: "url(#paint52_linear_47_2)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M267.04 339.105C263.619 338.341 260.364 336.96 257.438 334.79C254.643 332.724 252.151 329.937 250.12 326.291C254.921 305.144 263.975 288.624 250.302 272.277C244.738 265.636 239.017 262.016 233.704 257.936C225.935 251.964 219.068 244.984 214.944 226.094C212.618 215.442 211.88 209.643 211.776 206.379C211.68 203.645 212.036 202.672 212.279 202.108C212.401 201.822 212.965 201.466 213.816 201.118C216.246 200.146 221.021 199.313 224.763 200.736C225.44 200.997 226.082 201.327 226.672 201.752C226.655 202.941 226.725 204.278 226.863 205.728C228.426 222.066 239.772 252.554 262.708 247.502C263.367 247.363 264.036 247.189 264.713 246.981C264.713 246.981 262.647 250.054 262.239 258.483C262.126 260.862 262.143 263.674 262.378 266.956C263.237 279.014 267.934 317.072 267.031 339.105H267.04Z",
    fill: "url(#paint53_linear_47_2)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M308.569 323.809C309.723 325.536 305.695 329.495 299.158 333.045C296.788 334.339 294.08 335.58 291.18 336.631C292.717 316.707 286.805 272.468 285.946 259.725C285.711 256.304 285.199 253.379 284.574 250.922C282.612 243.335 279.452 240.131 279.452 240.131C280.034 239.767 280.598 239.402 281.154 239.02C296.866 228.368 302.058 213.211 298.985 201.032C295.981 189.147 286.779 176.212 282.933 170.144C281.779 168.313 281.102 167.106 281.223 166.741C281.371 166.281 281.892 165.309 282.69 164.163C284.261 161.915 286.953 159.024 290.191 158.199C291.076 157.973 291.996 157.904 292.951 158.043C294.054 158.199 295.582 159.267 297.344 161.038C305.539 169.241 318.89 192.533 318.89 209.921C318.89 231.068 304.679 250.609 303.612 259.49C302.544 268.371 299.705 308.703 308.586 323.809H308.569Z",
    fill: "url(#paint54_linear_47_2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M264.711 246.98C264.711 246.98 262.645 250.054 262.237 258.483L257.158 256.651C258.816 252.033 262.688 247.51 262.688 247.51H262.697C263.357 247.362 264.025 247.189 264.702 246.98H264.711Z",
    fill: "url(#paint55_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M289.916 248.543C289.916 248.543 286.73 248.873 284.568 250.93C282.606 243.343 279.446 240.14 279.446 240.14C280.028 239.775 280.592 239.411 281.148 239.029C283.162 240.018 287.303 242.666 289.916 248.543Z",
    fill: "url(#paint56_linear_47_2)"
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M222.737 195.528C221.339 193.47 219.49 192.455 217.58 191.934C217.432 189.738 217.511 187.029 218.847 187.064C221.096 187.125 222.737 195.528 222.737 195.528Z",
    fill: "url(#paint57_linear_47_2)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M290.622 146.41C290.439 149.874 288.877 151.645 289.198 155.031C289.319 156.255 289.719 157.331 290.17 158.208C286.941 159.033 284.25 161.924 282.67 164.172C278.633 160.986 277.8 159.033 277.287 155.291C276.758 151.385 275.69 147.921 276.758 146.853C277.826 145.785 280.135 150.317 281.819 151.471C283.503 152.626 285.725 147.739 286.437 144.631C287.149 141.523 285.014 136.28 287.948 136.549C290.882 136.809 290.795 142.947 290.613 146.41H290.622Z",
    fill: "url(#paint58_linear_47_2)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M262.222 228.594C262.091 229.705 259.999 229.879 259.687 231.172C259.374 232.457 261.64 233.039 261.64 233.039",
    stroke: "#F98267",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 196,
    width: 41,
    height: 33
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M280.08 228.403C278.9 228.117 277.788 228.594 277.788 228.594C277.788 228.594 275.922 220.686 275.479 220.426C275.036 220.156 263.308 222.917 256.91 219.445C249.097 216.684 245.364 206.032 251.676 198.567C257.978 191.101 267.927 205.407 273.969 207.265C280.011 209.131 286.313 206.64 288.188 215.078C289.595 221.459 283.596 224.592 280.08 228.386V228.403Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_47_2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M246.863 205.008C246.863 205.008 246.151 209.114 251.012 212.509C255.865 215.903 272.932 213.142 278.314 217.656C283.697 222.179 278.965 230.808 278.965 230.808C278.965 230.808 285.198 229.879 284.686 222.535C284.174 215.191 275.285 213.767 263.86 209.739C252.436 205.711 252.314 193.627 252.314 193.627C252.314 193.627 255.075 201.796 262.22 205.112C269.364 208.428 288.923 208.264 287.247 225.226",
    stroke: "white",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M226.855 205.728C220.665 203.827 214.866 205.259 211.776 206.379C211.68 203.645 212.036 202.672 212.279 202.108C212.401 201.822 212.965 201.466 213.816 201.118C216.246 200.146 221.021 199.313 224.763 200.736C225.44 200.997 226.082 201.327 226.672 201.752C226.655 202.941 226.725 204.278 226.863 205.728H226.855Z",
    fill: "url(#paint59_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M297.337 161.038C290.531 160.213 284.723 167.601 282.926 170.162C281.772 168.33 281.095 167.123 281.216 166.759C281.364 166.299 281.885 165.326 282.683 164.18C284.255 161.932 286.946 159.041 290.184 158.217C291.069 157.991 291.989 157.921 292.944 158.06C294.047 158.217 295.575 159.284 297.337 161.055V161.038Z",
    fill: "url(#paint60_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M291.189 336.63C283.741 339.348 274.964 340.884 267.038 339.104C267.221 334.66 267.169 329.555 266.978 324.156C272.742 319.077 279.617 315.301 278.575 306.012C276.857 290.707 278.827 288.971 283.324 267.65C284.609 261.539 285.156 257.242 285.286 254.203C285.581 255.879 285.816 257.719 285.954 259.724C286.814 272.468 292.726 316.707 291.189 336.63Z",
    fill: "url(#paint61_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.92,
    d: "M308.567 323.808C309.722 325.536 305.694 329.495 299.157 333.045C303.845 316.586 296.361 295.977 297.325 278.207C298.289 260.445 298.497 253.335 308.446 239.029C318.394 224.722 318.872 209.921 318.872 209.921C318.872 231.068 304.661 250.609 303.593 259.49C302.525 268.371 299.686 308.703 308.567 323.808Z",
    fill: "url(#paint62_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M277.247 246.868C276.51 246.339 275.772 245.653 274.374 245.245C271.179 244.29 269.929 245.861 266.379 245.601C265.867 245.557 265.415 245.505 265.016 245.436C264.938 244.741 264.833 244.029 264.712 243.352C268.688 243.292 272.916 241.356 276.102 236.72C276.648 239.915 278.098 242.302 278.28 243.066C278.428 243.691 278.072 245.245 277.247 246.868Z",
    fill: "url(#paint63_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M279.298 231.094C277.866 231.294 277.744 233.169 278.873 233.49C280.001 233.82 280.974 230.851 279.298 231.094Z",
    fill: "url(#paint64_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M277.761 228.49C277.561 229.358 277.266 229.922 276.806 229.818C275.183 229.462 274.106 226.858 271.085 225.912C268.064 224.965 265.521 225.912 264.097 224.549C262.673 223.186 261.38 223.542 257.821 222.474C257.031 222.24 256.458 221.953 256.032 221.667C256.518 220.295 256.9 219.444 256.9 219.444C263.298 222.908 275.026 220.156 275.469 220.425C275.886 220.668 277.535 227.57 277.752 228.49H277.761Z",
    fill: "url(#paint65_linear_47_2)"
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M218.674 240.14L218.692 241.13C218.631 240.496 218.674 240.14 218.674 240.14Z",
    fill: "url(#paint66_linear_47_2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.92,
    d: "M259.662 317.41C261.806 324.277 257.309 328.904 257.439 334.79C254.644 332.724 252.152 329.937 250.121 326.291C254.922 305.144 263.976 288.624 250.303 272.277C244.739 265.636 239.018 262.016 233.705 257.936C249.774 267.129 257.118 271.574 259.662 282.59C262.205 293.607 256.944 308.703 259.662 317.41Z",
    fill: "url(#paint67_linear_47_2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 208,
    width: 231,
    height: 161
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M230.718 248.839L229.19 293.738L167.606 337.256C166.148 338.029 163.621 355.79 155.531 368.213C142.57 366.894 128.975 363.491 115.763 358.021C99.39 351.242 83.5904 341.302 70.3256 328.271L52.9374 341.953L25.453 356.329L0 335.711C0 335.711 38.5615 308.062 44.673 287.826C50.6977 267.868 65.5857 260.811 67.0268 259.691C67.0442 259.673 86.5419 224.732 86.5419 224.732L114.877 208.785L174.603 239.273L230.726 248.831L230.718 248.839Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_47_2)"
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M129.842 219.957C121.786 216.05 111.482 219.132 107.81 223.629C104.138 228.126 104.372 239.264 100.587 245.896C96.802 252.528 83.4158 262.243 88.5029 271.358C93.59 280.473 137.534 280.004 140.503 270.524C143.472 261.045 137.898 257.494 138.489 248.969C139.079 240.444 141.683 231.676 137.421 224.81C133.159 217.943 129.842 219.957 129.842 219.957Z",
    fill: "#CE4D34"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 218,
    width: 55,
    height: 60
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M129.844 219.957C121.788 216.05 111.484 219.132 107.812 223.629C104.14 228.126 104.374 239.263 100.589 245.896C96.804 252.528 83.4177 262.242 88.5049 271.358C93.592 280.473 137.536 280.004 140.505 270.524C143.474 261.044 137.9 257.494 138.491 248.969C139.081 240.444 141.685 231.676 137.423 224.809C133.16 217.943 129.844 219.957 129.844 219.957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_47_2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.33
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M131.665 223.604C131.621 221.086 129.217 220.435 127.09 220.426C124.025 220.409 120.536 220.643 117.975 222.518C115.7 224.177 114.441 226.824 113.521 229.411C112.167 233.257 111.308 237.276 110.361 241.235C108.469 249.109 106.307 257.625 100.43 263.571C94.7961 269.284 86.6358 271.002 79.0659 272.548C78.7534 272.608 78.8836 273.095 79.1961 273.025C85.2989 271.784 91.6448 270.473 96.949 267.026C102.158 263.641 105.43 258.319 107.592 252.607C110.188 245.766 111.247 238.474 113.374 231.495C114.381 228.178 115.691 224.472 118.799 222.553C121.03 221.182 131.092 218.985 131.161 223.604C131.161 223.925 131.665 223.925 131.656 223.604H131.665Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M129.877 223.733C118.062 226.711 117.584 242.641 115.631 252.234C114.346 258.536 112.645 265.524 107.636 269.978C102.219 274.796 94.7181 275.777 87.808 276.645C87.4954 276.688 87.4868 277.183 87.808 277.14C93.7198 276.402 99.866 275.62 105.066 272.469C109.953 269.509 112.697 264.708 114.363 259.378C116.377 252.911 117.081 246.131 118.591 239.542C120.067 233.109 122.94 225.991 130.007 224.211C130.319 224.133 130.189 223.655 129.877 223.733Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M130.85 224.029C134.583 222.44 137.821 225.392 139.28 228.595C140.46 231.191 141.007 234.107 141.485 236.903C142.422 242.433 142.804 248.127 144.87 253.388C147.822 260.897 155.939 267.877 164.195 263.302C164.472 263.146 164.221 262.712 163.943 262.868C158.3 266.002 151.867 263.241 148.221 258.432C144.766 253.866 143.664 248.127 142.839 242.589C142.11 237.667 141.745 232.198 139.41 227.709C137.717 224.463 134.279 222.032 130.599 223.595C130.304 223.716 130.555 224.15 130.85 224.029Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M130.198 223.899C118.392 222.206 113.209 235.002 108.738 243.388C105.804 248.891 101.932 253.562 96.1158 256.105C90.2301 258.675 81.3493 259.291 78.2501 252.347C78.1199 252.051 77.6859 252.303 77.8161 252.598C82.6688 263.476 98.4077 257.312 104.293 250.871C108.348 246.435 110.44 240.696 113.348 235.531C116.768 229.446 122.368 223.274 130.068 224.376C130.38 224.419 130.519 223.942 130.198 223.899Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M117.577 221.026C111.874 222.562 109.33 228.127 106.848 232.945C105.172 236.192 103.254 239.369 100.016 241.261C96.847 243.119 93.1401 243.623 89.5809 242.807C89.2684 242.737 89.1381 243.215 89.4507 243.284C95.0413 244.577 100.806 242.598 104.339 238.049C108.636 232.519 110.025 223.569 117.716 221.494C118.029 221.408 117.899 220.93 117.586 221.017L117.577 221.026Z",
    fill: "white"
  })))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M131.884 258.892C129.87 259.908 127.587 260.402 125.312 260.42C119.965 260.472 114.678 257.859 113.054 252.937C112.777 253.015 112.508 253.076 112.247 253.119C108.427 253.718 106.448 250.35 106.613 248.188C106.795 245.879 108.566 244.855 109.547 244.499C110.528 244.143 110.884 247.789 111.909 248.101C112.586 248.31 112.516 246.504 112.56 245.15C112.577 244.464 112.62 243.9 112.803 243.752C113.332 243.309 121.328 239.932 122.708 237.267C123.993 239.846 124.531 239.976 125.503 239.663C126.475 239.351 131.502 235.575 132.118 233.439C132.396 236.347 133.82 238.5 134.653 239.542C135.018 239.993 135.269 240.236 135.269 240.236C135.269 240.236 138.646 255.515 131.892 258.892H131.884Z",
    fill: "url(#paint68_linear_47_2)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M123.665 362.544C120.097 364.35 108.743 365.357 101.016 360.851C96.945 344.704 101.19 298.2 102.718 284.978C104.211 272.13 108.925 262.052 109.22 261.435L109.237 261.409C114.212 260.107 127.589 263.475 128.423 263.684C128.449 263.744 129.048 264.291 129.074 264.37C129.187 264.96 128.683 266.262 128.726 268.849C128.162 287.583 119.733 349.149 123.665 362.544Z",
    fill: "url(#paint69_linear_47_2)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M211.21 261.409C210.593 264.222 209.256 268.137 204.282 269.995C201.33 271.098 198.822 272.86 196.912 274.744C195.67 271.679 192.814 269.361 190.757 268.337C192.38 265.602 194.012 257.546 195.21 256.583C196.547 255.515 197.615 260.133 197.528 262.269C197.433 264.396 206.6 257.381 207.346 254.716C208.093 252.051 209.604 253.206 209.777 254.716C209.959 256.227 211.817 258.588 211.201 261.409H211.21Z",
    fill: "url(#paint70_linear_47_2)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8835 331.735C35.0725 335.493 26.6692 342.482 22.8061 342.482C18.2746 342.482 15.3403 339.817 14.4549 337.95C13.5694 336.084 10.9043 335.554 10.9043 334.486C10.9043 333.419 21.122 331.995 24.4034 329.868C22.6325 329.686 20.2278 326.318 20.6792 325.337C21.122 324.356 22.9016 325.423 26.8949 325.337C30.8882 325.25 32.0428 323.765 32.0428 323.765C33.4404 325.406 36.9042 327.533 38.8922 331.735H38.8835Z",
    fill: "url(#paint71_linear_47_2)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M125.312 260.42C125.251 260.793 125.216 261.184 125.19 261.574C125.043 263.614 125.173 265.785 123.984 266.687C119.192 270.082 112.941 264.725 111.761 262.217C111.578 261.826 111.518 261.505 111.604 261.296C112.117 260.081 112.229 255.159 112.247 253.119C112.507 253.075 112.776 253.023 113.054 252.937C114.678 257.859 119.964 260.472 125.312 260.42Z",
    fill: "url(#paint72_linear_47_2)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1064 300.022C53.446 311.742 31.2397 320.458 31.422 322.585C31.4481 322.967 31.6738 323.349 32.0384 323.757C33.436 325.397 36.8998 327.524 38.8878 331.726C39.235 332.455 39.5388 333.254 39.7732 334.122C66.2419 327.55 85.3143 304.988 85.3143 304.988C85.3143 304.988 85.4359 311.976 84.724 317.775C84.0122 323.583 77.2583 339.808 77.9788 347.265C78.4128 351.849 86.9464 357.023 93.518 359.688C97.6328 361.354 100.984 362.049 101.071 361.007C101.053 360.955 101.044 360.894 101.027 360.834C96.9557 344.687 101.201 298.182 102.729 284.961C104.222 272.113 108.936 262.034 109.231 261.418L109.248 261.391C76.0255 268.623 74.7841 288.277 64.1151 300.005L64.1064 300.022Z",
    fill: "url(#paint73_linear_47_2)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M196.908 274.743C196.882 274.683 196.856 274.622 196.821 274.561C195.554 271.583 192.767 269.344 190.753 268.337C189.928 267.92 189.225 267.712 188.817 267.738C187.046 267.859 177.445 282.964 161.454 281.723C145.464 280.473 144.917 267.59 128.405 263.684C128.431 263.744 128.457 263.822 128.483 263.901C128.726 264.691 128.787 266.401 128.709 268.849C128.145 287.583 119.716 349.149 123.648 362.544C123.744 362.874 123.848 363.178 123.961 363.456C126.096 366.294 135.602 356.346 136.088 350.66C136.574 344.973 128.935 320.866 131.07 313.826C133.206 306.777 141.201 305.006 137.642 291.151C137.642 291.151 137.642 291.151 137.659 291.159C152.235 305.006 182.063 304.389 197.516 278.059C197.55 276.888 197.316 275.785 196.899 274.761L196.908 274.743Z",
    fill: "url(#paint74_linear_47_2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 261,
    width: 167,
    height: 103
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M109.233 261.409L109.216 261.435C108.921 262.051 104.207 272.13 102.714 284.978C101.177 298.2 96.941 344.704 101.012 360.851C101.03 360.912 101.038 360.964 101.056 361.025C100.821 363.742 78.6673 354.748 77.9641 347.283C77.2523 339.817 83.9975 323.6 84.7093 317.793C85.4212 311.994 85.2997 305.006 85.2997 305.006C85.2997 305.006 66.2273 327.568 39.7586 334.139C39.5155 333.271 39.2117 332.473 38.8731 331.743C36.8851 327.542 33.4214 325.415 32.0237 323.774C31.6678 323.357 31.4421 322.975 31.4074 322.602C31.2251 320.467 53.44 311.759 64.0917 300.04C74.7521 288.312 76.0022 268.649 109.225 261.426L109.233 261.409ZM196.913 274.743C195.671 271.679 192.815 269.361 190.758 268.337C189.933 267.92 189.23 267.712 188.822 267.738C187.051 267.859 177.45 282.964 161.459 281.723C145.468 280.473 144.921 267.59 128.41 263.684C128.436 263.744 128.462 263.822 128.488 263.901C128.731 264.691 128.792 266.401 128.714 268.849C128.15 287.583 119.72 349.149 123.653 362.544C123.748 362.874 123.852 363.178 123.965 363.455C126.101 366.294 135.607 356.346 136.093 350.659C136.579 344.973 128.94 320.866 131.075 313.826C133.211 306.777 141.206 305.006 137.647 291.151C152.214 305.006 182.059 304.407 197.52 278.059C197.555 276.887 197.321 275.785 196.904 274.761L196.913 274.743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_47_2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 275.794C75.6145 275.794 76.0732 275.335 76.0732 274.77C76.0732 274.204 75.6145 273.745 75.0488 273.745C74.483 273.745 74.0244 274.204 74.0244 274.77C74.0244 275.335 74.483 275.794 75.0488 275.794Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4794 275.794C82.0452 275.794 82.5038 275.335 82.5038 274.769C82.5038 274.204 82.0452 273.745 81.4794 273.745C80.9137 273.745 80.4551 274.204 80.4551 274.769C80.4551 275.335 80.9137 275.794 81.4794 275.794Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M87.913 275.794C88.4788 275.794 88.9374 275.335 88.9374 274.769C88.9374 274.204 88.4788 273.745 87.913 273.745C87.3473 273.745 86.8887 274.204 86.8887 274.769C86.8887 275.335 87.3473 275.794 87.913 275.794Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3378 275.794C94.9036 275.794 95.3622 275.335 95.3622 274.769C95.3622 274.204 94.9036 273.745 94.3378 273.745C93.7721 273.745 93.3135 274.204 93.3135 274.769C93.3135 275.335 93.7721 275.794 94.3378 275.794Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 275.794C101.335 275.794 101.794 275.335 101.794 274.769C101.794 274.204 101.335 273.745 100.769 273.745C100.204 273.745 99.7451 274.204 99.7451 274.769C99.7451 275.335 100.204 275.794 100.769 275.794Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 281.158C75.6145 281.158 76.0732 280.699 76.0732 280.133C76.0732 279.568 75.6145 279.109 75.0488 279.109C74.483 279.109 74.0244 279.568 74.0244 280.133C74.0244 280.699 74.483 281.158 75.0488 281.158Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4794 281.158C82.0452 281.158 82.5038 280.699 82.5038 280.133C82.5038 279.568 82.0452 279.109 81.4794 279.109C80.9137 279.109 80.4551 279.568 80.4551 280.133C80.4551 280.699 80.9137 281.158 81.4794 281.158Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M87.913 281.158C88.4788 281.158 88.9374 280.699 88.9374 280.133C88.9374 279.568 88.4788 279.109 87.913 279.109C87.3473 279.109 86.8887 279.568 86.8887 280.133C86.8887 280.699 87.3473 281.158 87.913 281.158Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3378 281.158C94.9036 281.158 95.3622 280.699 95.3622 280.133C95.3622 279.568 94.9036 279.109 94.3378 279.109C93.7721 279.109 93.3135 279.568 93.3135 280.133C93.3135 280.699 93.7721 281.158 94.3378 281.158Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 281.158C101.335 281.158 101.794 280.699 101.794 280.133C101.794 279.568 101.335 279.109 100.769 279.109C100.204 279.109 99.7451 279.568 99.7451 280.133C99.7451 280.699 100.204 281.158 100.769 281.158Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 286.515C75.6145 286.515 76.0732 286.056 76.0732 285.49C76.0732 284.924 75.6145 284.466 75.0488 284.466C74.483 284.466 74.0244 284.924 74.0244 285.49C74.0244 286.056 74.483 286.515 75.0488 286.515Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4794 286.514C82.0452 286.514 82.5038 286.056 82.5038 285.49C82.5038 284.924 82.0452 284.466 81.4794 284.466C80.9137 284.466 80.4551 284.924 80.4551 285.49C80.4551 286.056 80.9137 286.514 81.4794 286.514Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M87.913 286.515C88.4788 286.515 88.9374 286.056 88.9374 285.49C88.9374 284.925 88.4788 284.466 87.913 284.466C87.3473 284.466 86.8887 284.925 86.8887 285.49C86.8887 286.056 87.3473 286.515 87.913 286.515Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3378 286.515C94.9036 286.515 95.3622 286.056 95.3622 285.49C95.3622 284.925 94.9036 284.466 94.3378 284.466C93.7721 284.466 93.3135 284.925 93.3135 285.49C93.3135 286.056 93.7721 286.515 94.3378 286.515Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 286.514C101.335 286.514 101.794 286.056 101.794 285.49C101.794 284.924 101.335 284.466 100.769 284.466C100.204 284.466 99.7451 284.924 99.7451 285.49C99.7451 286.056 100.204 286.514 100.769 286.514Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 291.87C75.6145 291.87 76.0732 291.412 76.0732 290.846C76.0732 290.28 75.6145 289.822 75.0488 289.822C74.483 289.822 74.0244 290.28 74.0244 290.846C74.0244 291.412 74.483 291.87 75.0488 291.87Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4794 291.87C82.0452 291.87 82.5038 291.412 82.5038 290.846C82.5038 290.28 82.0452 289.822 81.4794 289.822C80.9137 289.822 80.4551 290.28 80.4551 290.846C80.4551 291.412 80.9137 291.87 81.4794 291.87Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M87.913 291.871C88.4788 291.871 88.9374 291.412 88.9374 290.846C88.9374 290.28 88.4788 289.822 87.913 289.822C87.3473 289.822 86.8887 290.28 86.8887 290.846C86.8887 291.412 87.3473 291.871 87.913 291.871Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3378 291.871C94.9036 291.871 95.3622 291.412 95.3622 290.846C95.3622 290.28 94.9036 289.822 94.3378 289.822C93.7721 289.822 93.3135 290.28 93.3135 290.846C93.3135 291.412 93.7721 291.871 94.3378 291.871Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 291.87C101.335 291.87 101.794 291.412 101.794 290.846C101.794 290.28 101.335 289.822 100.769 289.822C100.204 289.822 99.7451 290.28 99.7451 290.846C99.7451 291.412 100.204 291.87 100.769 291.87Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 297.227C75.6145 297.227 76.0732 296.768 76.0732 296.202C76.0732 295.637 75.6145 295.178 75.0488 295.178C74.483 295.178 74.0244 295.637 74.0244 296.202C74.0244 296.768 74.483 297.227 75.0488 297.227Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4794 297.227C82.0452 297.227 82.5038 296.768 82.5038 296.202C82.5038 295.637 82.0452 295.178 81.4794 295.178C80.9137 295.178 80.4551 295.637 80.4551 296.202C80.4551 296.768 80.9137 297.227 81.4794 297.227Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M87.913 297.227C88.4788 297.227 88.9374 296.768 88.9374 296.203C88.9374 295.637 88.4788 295.178 87.913 295.178C87.3473 295.178 86.8887 295.637 86.8887 296.203C86.8887 296.768 87.3473 297.227 87.913 297.227Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3378 297.227C94.9036 297.227 95.3622 296.768 95.3622 296.203C95.3622 295.637 94.9036 295.178 94.3378 295.178C93.7721 295.178 93.3135 295.637 93.3135 296.203C93.3135 296.768 93.7721 297.227 94.3378 297.227Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 297.227C101.335 297.227 101.794 296.768 101.794 296.202C101.794 295.637 101.335 295.178 100.769 295.178C100.204 295.178 99.7451 295.637 99.7451 296.202C99.7451 296.768 100.204 297.227 100.769 297.227Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 302.584C75.6145 302.584 76.0732 302.125 76.0732 301.559C76.0732 300.993 75.6145 300.535 75.0488 300.535C74.483 300.535 74.0244 300.993 74.0244 301.559C74.0244 302.125 74.483 302.584 75.0488 302.584Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4794 302.583C82.0452 302.583 82.5038 302.125 82.5038 301.559C82.5038 300.993 82.0452 300.535 81.4794 300.535C80.9137 300.535 80.4551 300.993 80.4551 301.559C80.4551 302.125 80.9137 302.583 81.4794 302.583Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M87.913 302.584C88.4788 302.584 88.9374 302.125 88.9374 301.559C88.9374 300.993 88.4788 300.535 87.913 300.535C87.3473 300.535 86.8887 300.993 86.8887 301.559C86.8887 302.125 87.3473 302.584 87.913 302.584Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3378 302.584C94.9036 302.584 95.3622 302.125 95.3622 301.559C95.3622 300.993 94.9036 300.535 94.3378 300.535C93.7721 300.535 93.3135 300.993 93.3135 301.559C93.3135 302.125 93.7721 302.584 94.3378 302.584Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 302.583C101.335 302.583 101.794 302.125 101.794 301.559C101.794 300.993 101.335 300.535 100.769 300.535C100.204 300.535 99.7451 300.993 99.7451 301.559C99.7451 302.125 100.204 302.583 100.769 302.583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 287.026C156.422 287.026 156.881 286.568 156.881 286.002C156.881 285.436 156.422 284.978 155.856 284.978C155.291 284.978 154.832 285.436 154.832 286.002C154.832 286.568 155.291 287.026 155.856 287.026Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 287.026C162.848 287.026 163.307 286.568 163.307 286.002C163.307 285.436 162.848 284.978 162.282 284.978C161.716 284.978 161.258 285.436 161.258 286.002C161.258 286.568 161.716 287.026 162.282 287.026Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M168.713 287.026C169.279 287.026 169.737 286.568 169.737 286.002C169.737 285.436 169.279 284.977 168.713 284.977C168.147 284.977 167.688 285.436 167.688 286.002C167.688 286.568 168.147 287.026 168.713 287.026Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 287.026C175.709 287.026 176.168 286.568 176.168 286.002C176.168 285.436 175.709 284.978 175.144 284.978C174.578 284.978 174.119 285.436 174.119 286.002C174.119 286.568 174.578 287.026 175.144 287.026Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M181.57 287.026C182.136 287.026 182.595 286.568 182.595 286.002C182.595 285.436 182.136 284.977 181.57 284.977C181.005 284.977 180.546 285.436 180.546 286.002C180.546 286.568 181.005 287.026 181.57 287.026Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 292.383C156.422 292.383 156.881 291.924 156.881 291.358C156.881 290.793 156.422 290.334 155.856 290.334C155.291 290.334 154.832 290.793 154.832 291.358C154.832 291.924 155.291 292.383 155.856 292.383Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 292.383C162.848 292.383 163.307 291.924 163.307 291.358C163.307 290.793 162.848 290.334 162.282 290.334C161.716 290.334 161.258 290.793 161.258 291.358C161.258 291.924 161.716 292.383 162.282 292.383Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M168.713 292.383C169.279 292.383 169.737 291.924 169.737 291.358C169.737 290.793 169.279 290.334 168.713 290.334C168.147 290.334 167.688 290.793 167.688 291.358C167.688 291.924 168.147 292.383 168.713 292.383Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 292.383C175.709 292.383 176.168 291.924 176.168 291.358C176.168 290.793 175.709 290.334 175.144 290.334C174.578 290.334 174.119 290.793 174.119 291.358C174.119 291.924 174.578 292.383 175.144 292.383Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M181.57 292.383C182.136 292.383 182.595 291.924 182.595 291.358C182.595 290.793 182.136 290.334 181.57 290.334C181.005 290.334 180.546 290.793 180.546 291.358C180.546 291.924 181.005 292.383 181.57 292.383Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 297.739C156.422 297.739 156.881 297.28 156.881 296.715C156.881 296.149 156.422 295.69 155.856 295.69C155.291 295.69 154.832 296.149 154.832 296.715C154.832 297.28 155.291 297.739 155.856 297.739Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 297.739C162.848 297.739 163.307 297.28 163.307 296.715C163.307 296.149 162.848 295.69 162.282 295.69C161.716 295.69 161.258 296.149 161.258 296.715C161.258 297.28 161.716 297.739 162.282 297.739Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M168.713 297.739C169.279 297.739 169.737 297.28 169.737 296.715C169.737 296.149 169.279 295.69 168.713 295.69C168.147 295.69 167.688 296.149 167.688 296.715C167.688 297.28 168.147 297.739 168.713 297.739Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 297.739C175.709 297.739 176.168 297.28 176.168 296.715C176.168 296.149 175.709 295.69 175.144 295.69C174.578 295.69 174.119 296.149 174.119 296.715C174.119 297.28 174.578 297.739 175.144 297.739Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M181.57 297.739C182.136 297.739 182.595 297.28 182.595 296.715C182.595 296.149 182.136 295.69 181.57 295.69C181.005 295.69 180.546 296.149 180.546 296.715C180.546 297.28 181.005 297.739 181.57 297.739Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 303.095C156.422 303.095 156.881 302.637 156.881 302.071C156.881 301.505 156.422 301.047 155.856 301.047C155.291 301.047 154.832 301.505 154.832 302.071C154.832 302.637 155.291 303.095 155.856 303.095Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 303.095C162.848 303.095 163.307 302.637 163.307 302.071C163.307 301.505 162.848 301.047 162.282 301.047C161.716 301.047 161.258 301.505 161.258 302.071C161.258 302.637 161.716 303.095 162.282 303.095Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M168.713 303.095C169.279 303.095 169.737 302.637 169.737 302.071C169.737 301.505 169.279 301.047 168.713 301.047C168.147 301.047 167.688 301.505 167.688 302.071C167.688 302.637 168.147 303.095 168.713 303.095Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 303.095C175.709 303.095 176.168 302.637 176.168 302.071C176.168 301.505 175.709 301.047 175.144 301.047C174.578 301.047 174.119 301.505 174.119 302.071C174.119 302.637 174.578 303.095 175.144 303.095Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M181.57 303.095C182.136 303.095 182.595 302.637 182.595 302.071C182.595 301.505 182.136 301.047 181.57 301.047C181.005 301.047 180.546 301.505 180.546 302.071C180.546 302.637 181.005 303.095 181.57 303.095Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 308.451C156.422 308.451 156.881 307.993 156.881 307.427C156.881 306.861 156.422 306.403 155.856 306.403C155.291 306.403 154.832 306.861 154.832 307.427C154.832 307.993 155.291 308.451 155.856 308.451Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 308.451C162.848 308.451 163.307 307.993 163.307 307.427C163.307 306.861 162.848 306.403 162.282 306.403C161.716 306.403 161.258 306.861 161.258 307.427C161.258 307.993 161.716 308.451 162.282 308.451Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M168.713 308.451C169.279 308.451 169.737 307.993 169.737 307.427C169.737 306.861 169.279 306.402 168.713 306.402C168.147 306.402 167.688 306.861 167.688 307.427C167.688 307.993 168.147 308.451 168.713 308.451Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 308.451C175.709 308.451 176.168 307.993 176.168 307.427C176.168 306.861 175.709 306.403 175.144 306.403C174.578 306.403 174.119 306.861 174.119 307.427C174.119 307.993 174.578 308.451 175.144 308.451Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M181.57 308.451C182.136 308.451 182.595 307.993 182.595 307.427C182.595 306.861 182.136 306.402 181.57 306.402C181.005 306.402 180.546 306.861 180.546 307.427C180.546 307.993 181.005 308.451 181.57 308.451Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 313.808C156.422 313.808 156.881 313.349 156.881 312.783C156.881 312.217 156.422 311.759 155.856 311.759C155.291 311.759 154.832 312.217 154.832 312.783C154.832 313.349 155.291 313.808 155.856 313.808Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 313.808C162.848 313.808 163.307 313.349 163.307 312.783C163.307 312.218 162.848 311.759 162.282 311.759C161.716 311.759 161.258 312.218 161.258 312.783C161.258 313.349 161.716 313.808 162.282 313.808Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M168.713 313.807C169.279 313.807 169.737 313.349 169.737 312.783C169.737 312.217 169.279 311.759 168.713 311.759C168.147 311.759 167.688 312.217 167.688 312.783C167.688 313.349 168.147 313.807 168.713 313.807Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 313.808C175.709 313.808 176.168 313.349 176.168 312.783C176.168 312.218 175.709 311.759 175.144 311.759C174.578 311.759 174.119 312.218 174.119 312.783C174.119 313.349 174.578 313.808 175.144 313.808Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M181.57 313.807C182.136 313.807 182.595 313.349 182.595 312.783C182.595 312.217 182.136 311.759 181.57 311.759C181.005 311.759 180.546 312.217 180.546 312.783C180.546 313.349 181.005 313.807 181.57 313.807Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9404 322.732C42.5061 322.732 42.9648 322.273 42.9648 321.707C42.9648 321.142 42.5061 320.683 41.9404 320.683C41.3746 320.683 40.916 321.142 40.916 321.707C40.916 322.273 41.3746 322.732 41.9404 322.732Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3632 322.732C48.929 322.732 49.3876 322.273 49.3876 321.707C49.3876 321.142 48.929 320.683 48.3632 320.683C47.7975 320.683 47.3389 321.142 47.3389 321.707C47.3389 322.273 47.7975 322.732 48.3632 322.732Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7988 322.732C55.3645 322.732 55.8232 322.273 55.8232 321.707C55.8232 321.142 55.3645 320.683 54.7988 320.683C54.233 320.683 53.7744 321.142 53.7744 321.707C53.7744 322.273 54.233 322.732 54.7988 322.732Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2294 322.732C61.7952 322.732 62.2538 322.273 62.2538 321.707C62.2538 321.141 61.7952 320.683 61.2294 320.683C60.6637 320.683 60.2051 321.141 60.2051 321.707C60.2051 322.273 60.6637 322.732 61.2294 322.732Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 322.732C68.22 322.732 68.6786 322.273 68.6786 321.707C68.6786 321.141 68.22 320.683 67.6543 320.683C67.0885 320.683 66.6299 321.141 66.6299 321.707C66.6299 322.273 67.0885 322.732 67.6543 322.732Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9404 328.089C42.5061 328.089 42.9648 327.63 42.9648 327.065C42.9648 326.499 42.5061 326.04 41.9404 326.04C41.3746 326.04 40.916 326.499 40.916 327.065C40.916 327.63 41.3746 328.089 41.9404 328.089Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3632 328.089C48.929 328.089 49.3876 327.63 49.3876 327.064C49.3876 326.499 48.929 326.04 48.3632 326.04C47.7975 326.04 47.3389 326.499 47.3389 327.064C47.3389 327.63 47.7975 328.089 48.3632 328.089Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7988 328.089C55.3645 328.089 55.8232 327.63 55.8232 327.064C55.8232 326.499 55.3645 326.04 54.7988 326.04C54.233 326.04 53.7744 326.499 53.7744 327.064C53.7744 327.63 54.233 328.089 54.7988 328.089Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2294 328.089C61.7952 328.089 62.2538 327.63 62.2538 327.064C62.2538 326.499 61.7952 326.04 61.2294 326.04C60.6637 326.04 60.2051 326.499 60.2051 327.064C60.2051 327.63 60.6637 328.089 61.2294 328.089Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 328.089C68.22 328.089 68.6786 327.63 68.6786 327.064C68.6786 326.499 68.22 326.04 67.6543 326.04C67.0885 326.04 66.6299 326.499 66.6299 327.064C66.6299 327.63 67.0885 328.089 67.6543 328.089Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9404 333.445C42.5061 333.445 42.9648 332.986 42.9648 332.42C42.9648 331.855 42.5061 331.396 41.9404 331.396C41.3746 331.396 40.916 331.855 40.916 332.42C40.916 332.986 41.3746 333.445 41.9404 333.445Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3632 333.445C48.929 333.445 49.3876 332.986 49.3876 332.42C49.3876 331.854 48.929 331.396 48.3632 331.396C47.7975 331.396 47.3389 331.854 47.3389 332.42C47.3389 332.986 47.7975 333.445 48.3632 333.445Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7988 333.445C55.3645 333.445 55.8232 332.986 55.8232 332.42C55.8232 331.854 55.3645 331.396 54.7988 331.396C54.233 331.396 53.7744 331.854 53.7744 332.42C53.7744 332.986 54.233 333.445 54.7988 333.445Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2294 333.444C61.7952 333.444 62.2538 332.986 62.2538 332.42C62.2538 331.854 61.7952 331.396 61.2294 331.396C60.6637 331.396 60.2051 331.854 60.2051 332.42C60.2051 332.986 60.6637 333.444 61.2294 333.444Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 333.444C68.22 333.444 68.6786 332.986 68.6786 332.42C68.6786 331.854 68.22 331.396 67.6543 331.396C67.0885 331.396 66.6299 331.854 66.6299 332.42C66.6299 332.986 67.0885 333.444 67.6543 333.444Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9404 338.801C42.5061 338.801 42.9648 338.342 42.9648 337.776C42.9648 337.211 42.5061 336.752 41.9404 336.752C41.3746 336.752 40.916 337.211 40.916 337.776C40.916 338.342 41.3746 338.801 41.9404 338.801Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3632 338.801C48.929 338.801 49.3876 338.342 49.3876 337.776C49.3876 337.21 48.929 336.752 48.3632 336.752C47.7975 336.752 47.3389 337.21 47.3389 337.776C47.3389 338.342 47.7975 338.801 48.3632 338.801Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7988 338.8C55.3645 338.8 55.8232 338.342 55.8232 337.776C55.8232 337.21 55.3645 336.752 54.7988 336.752C54.233 336.752 53.7744 337.21 53.7744 337.776C53.7744 338.342 54.233 338.8 54.7988 338.8Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2294 338.8C61.7952 338.8 62.2538 338.342 62.2538 337.776C62.2538 337.21 61.7952 336.752 61.2294 336.752C60.6637 336.752 60.2051 337.21 60.2051 337.776C60.2051 338.342 60.6637 338.8 61.2294 338.8Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 338.8C68.22 338.8 68.6786 338.342 68.6786 337.776C68.6786 337.21 68.22 336.752 67.6543 336.752C67.0885 336.752 66.6299 337.21 66.6299 337.776C66.6299 338.342 67.0885 338.8 67.6543 338.8Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9404 344.157C42.5061 344.157 42.9648 343.699 42.9648 343.133C42.9648 342.567 42.5061 342.109 41.9404 342.109C41.3746 342.109 40.916 342.567 40.916 343.133C40.916 343.699 41.3746 344.157 41.9404 344.157Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3632 344.157C48.929 344.157 49.3876 343.699 49.3876 343.133C49.3876 342.567 48.929 342.108 48.3632 342.108C47.7975 342.108 47.3389 342.567 47.3389 343.133C47.3389 343.699 47.7975 344.157 48.3632 344.157Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7988 344.157C55.3645 344.157 55.8232 343.698 55.8232 343.133C55.8232 342.567 55.3645 342.108 54.7988 342.108C54.233 342.108 53.7744 342.567 53.7744 343.133C53.7744 343.698 54.233 344.157 54.7988 344.157Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2294 344.157C61.7952 344.157 62.2538 343.698 62.2538 343.133C62.2538 342.567 61.7952 342.108 61.2294 342.108C60.6637 342.108 60.2051 342.567 60.2051 343.133C60.2051 343.698 60.6637 344.157 61.2294 344.157Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 344.157C68.22 344.157 68.6786 343.698 68.6786 343.133C68.6786 342.567 68.22 342.108 67.6543 342.108C67.0885 342.108 66.6299 342.567 66.6299 343.133C66.6299 343.698 67.0885 344.157 67.6543 344.157Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9404 349.513C42.5061 349.513 42.9648 349.054 42.9648 348.489C42.9648 347.923 42.5061 347.464 41.9404 347.464C41.3746 347.464 40.916 347.923 40.916 348.489C40.916 349.054 41.3746 349.513 41.9404 349.513Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3632 349.513C48.929 349.513 49.3876 349.054 49.3876 348.488C49.3876 347.923 48.929 347.464 48.3632 347.464C47.7975 347.464 47.3389 347.923 47.3389 348.488C47.3389 349.054 47.7975 349.513 48.3632 349.513Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7988 349.513C55.3645 349.513 55.8232 349.054 55.8232 348.488C55.8232 347.923 55.3645 347.464 54.7988 347.464C54.233 347.464 53.7744 347.923 53.7744 348.488C53.7744 349.054 54.233 349.513 54.7988 349.513Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2294 349.513C61.7952 349.513 62.2538 349.054 62.2538 348.488C62.2538 347.922 61.7952 347.464 61.2294 347.464C60.6637 347.464 60.2051 347.922 60.2051 348.488C60.2051 349.054 60.6637 349.513 61.2294 349.513Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 349.513C68.22 349.513 68.6786 349.054 68.6786 348.488C68.6786 347.922 68.22 347.464 67.6543 347.464C67.0885 347.464 66.6299 347.922 66.6299 348.488C66.6299 349.054 67.0885 349.513 67.6543 349.513Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M112.78 322.689C113.346 322.689 113.805 322.23 113.805 321.665C113.805 321.099 113.346 320.64 112.78 320.64C112.214 320.64 111.756 321.099 111.756 321.665C111.756 322.23 112.214 322.689 112.78 322.689Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 322.689C119.777 322.689 120.235 322.23 120.235 321.664C120.235 321.099 119.777 320.64 119.211 320.64C118.645 320.64 118.187 321.099 118.187 321.664C118.187 322.23 118.645 322.689 119.211 322.689Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 322.689C126.212 322.689 126.671 322.23 126.671 321.665C126.671 321.099 126.212 320.64 125.646 320.64C125.081 320.64 124.622 321.099 124.622 321.665C124.622 322.23 125.081 322.689 125.646 322.689Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M133.103 321.665C133.103 322.229 132.643 322.689 132.079 322.689C131.515 322.689 131.055 322.229 131.055 321.665C131.055 321.1 131.515 320.64 132.079 320.64C132.643 320.64 133.103 321.1 133.103 321.665Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 322.689C139.067 322.689 139.525 322.23 139.525 321.665C139.525 321.099 139.067 320.64 138.501 320.64C137.935 320.64 137.477 321.099 137.477 321.665C137.477 322.23 137.935 322.689 138.501 322.689Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M112.78 328.045C113.346 328.045 113.805 327.586 113.805 327.021C113.805 326.455 113.346 325.996 112.78 325.996C112.214 325.996 111.756 326.455 111.756 327.021C111.756 327.586 112.214 328.045 112.78 328.045Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 328.045C119.777 328.045 120.235 327.586 120.235 327.021C120.235 326.455 119.777 325.996 119.211 325.996C118.645 325.996 118.187 326.455 118.187 327.021C118.187 327.586 118.645 328.045 119.211 328.045Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 328.045C126.212 328.045 126.671 327.587 126.671 327.021C126.671 326.455 126.212 325.996 125.646 325.996C125.081 325.996 124.622 326.455 124.622 327.021C124.622 327.587 125.081 328.045 125.646 328.045Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M133.103 327.021C133.103 327.585 132.643 328.045 132.079 328.045C131.515 328.045 131.055 327.585 131.055 327.021C131.055 326.456 131.515 325.996 132.079 325.996C132.643 325.996 133.103 326.456 133.103 327.021Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 328.045C139.067 328.045 139.525 327.586 139.525 327.021C139.525 326.455 139.067 325.996 138.501 325.996C137.935 325.996 137.477 326.455 137.477 327.021C137.477 327.586 137.935 328.045 138.501 328.045Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M112.78 333.41C113.346 333.41 113.805 332.951 113.805 332.385C113.805 331.82 113.346 331.361 112.78 331.361C112.214 331.361 111.756 331.82 111.756 332.385C111.756 332.951 112.214 333.41 112.78 333.41Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 333.41C119.777 333.41 120.235 332.951 120.235 332.385C120.235 331.819 119.777 331.361 119.211 331.361C118.645 331.361 118.187 331.819 118.187 332.385C118.187 332.951 118.645 333.41 119.211 333.41Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 333.41C126.212 333.41 126.671 332.951 126.671 332.386C126.671 331.82 126.212 331.361 125.646 331.361C125.081 331.361 124.622 331.82 124.622 332.386C124.622 332.951 125.081 333.41 125.646 333.41Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M133.103 332.385C133.103 332.95 132.643 333.41 132.079 333.41C131.515 333.41 131.055 332.95 131.055 332.385C131.055 331.821 131.515 331.361 132.079 331.361C132.643 331.361 133.103 331.821 133.103 332.385Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 333.41C139.067 333.41 139.525 332.951 139.525 332.385C139.525 331.819 139.067 331.361 138.501 331.361C137.935 331.361 137.477 331.819 137.477 332.385C137.477 332.951 137.935 333.41 138.501 333.41Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M112.78 338.766C113.346 338.766 113.805 338.307 113.805 337.742C113.805 337.176 113.346 336.717 112.78 336.717C112.214 336.717 111.756 337.176 111.756 337.742C111.756 338.307 112.214 338.766 112.78 338.766Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 338.766C119.777 338.766 120.235 338.307 120.235 337.741C120.235 337.176 119.777 336.717 119.211 336.717C118.645 336.717 118.187 337.176 118.187 337.741C118.187 338.307 118.645 338.766 119.211 338.766Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 338.766C126.212 338.766 126.671 338.308 126.671 337.742C126.671 337.176 126.212 336.717 125.646 336.717C125.081 336.717 124.622 337.176 124.622 337.742C124.622 338.308 125.081 338.766 125.646 338.766Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M133.103 337.742C133.103 338.306 132.643 338.766 132.079 338.766C131.515 338.766 131.055 338.306 131.055 337.742C131.055 337.177 131.515 336.717 132.079 336.717C132.643 336.717 133.103 337.177 133.103 337.742Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 338.766C139.067 338.766 139.525 338.307 139.525 337.741C139.525 337.176 139.067 336.717 138.501 336.717C137.935 336.717 137.477 337.176 137.477 337.741C137.477 338.307 137.935 338.766 138.501 338.766Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M112.78 344.122C113.346 344.122 113.805 343.663 113.805 343.098C113.805 342.532 113.346 342.073 112.78 342.073C112.214 342.073 111.756 342.532 111.756 343.098C111.756 343.663 112.214 344.122 112.78 344.122Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 344.122C119.777 344.122 120.235 343.663 120.235 343.098C120.235 342.532 119.777 342.073 119.211 342.073C118.645 342.073 118.187 342.532 118.187 343.098C118.187 343.663 118.645 344.122 119.211 344.122Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 344.122C126.212 344.122 126.671 343.664 126.671 343.098C126.671 342.532 126.212 342.074 125.646 342.074C125.081 342.074 124.622 342.532 124.622 343.098C124.622 343.664 125.081 344.122 125.646 344.122Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M133.103 343.098C133.103 343.662 132.643 344.122 132.079 344.122C131.515 344.122 131.055 343.662 131.055 343.098C131.055 342.534 131.515 342.073 132.079 342.073C132.643 342.073 133.103 342.534 133.103 343.098Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 344.122C139.067 344.122 139.525 343.663 139.525 343.098C139.525 342.532 139.067 342.073 138.501 342.073C137.935 342.073 137.477 342.532 137.477 343.098C137.477 343.663 137.935 344.122 138.501 344.122Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M112.78 349.479C113.346 349.479 113.805 349.02 113.805 348.454C113.805 347.888 113.346 347.43 112.78 347.43C112.214 347.43 111.756 347.888 111.756 348.454C111.756 349.02 112.214 349.479 112.78 349.479Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 349.478C119.777 349.478 120.235 349.02 120.235 348.454C120.235 347.888 119.777 347.429 119.211 347.429C118.645 347.429 118.187 347.888 118.187 348.454C118.187 349.02 118.645 349.478 119.211 349.478Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M125.646 349.479C126.212 349.479 126.671 349.02 126.671 348.454C126.671 347.888 126.212 347.43 125.646 347.43C125.081 347.43 124.622 347.888 124.622 348.454C124.622 349.02 125.081 349.479 125.646 349.479Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M133.103 348.454C133.103 349.018 132.643 349.479 132.079 349.479C131.515 349.479 131.055 349.018 131.055 348.454C131.055 347.89 131.515 347.43 132.079 347.43C132.643 347.43 133.103 347.89 133.103 348.454Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 349.478C139.067 349.478 139.525 349.02 139.525 348.454C139.525 347.888 139.067 347.43 138.501 347.43C137.935 347.43 137.477 347.888 137.477 348.454C137.477 349.02 137.935 349.478 138.501 349.478Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M197.539 278.042C182.086 304.381 152.258 304.997 137.683 291.142C138.099 291.342 145.99 295.057 152.579 293.703C159.342 292.314 162.189 294.918 169.655 294.562C177.121 294.206 177.121 289.111 181.852 288.399C186.592 287.687 186.349 283.138 191.445 281.41C194.474 280.386 196.054 277.07 196.844 274.544C196.879 274.604 196.905 274.665 196.931 274.726C197.348 275.75 197.582 276.853 197.548 278.025L197.539 278.042Z",
    fill: "url(#paint75_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M87.3653 351.423C88.5286 354.939 91.7493 357.474 93.5028 359.705C86.9312 357.031 78.3977 351.866 77.9637 347.282C77.2518 339.816 83.997 323.6 84.7089 317.792C85.4207 311.993 85.2992 305.005 85.2992 305.005C85.2992 305.005 90.395 299.675 92.409 293.754C95.8467 301.81 90.0391 305.838 90.6294 314.485C91.2197 323.131 83.2852 332.611 86.011 339.946C88.7369 347.291 85.8635 346.935 87.3653 351.432V351.423Z",
    fill: "url(#paint76_linear_47_2)"
  }), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M128.013 245.245C128.013 245.245 127.753 246.842 129.099 247.736C130.444 248.622 129.75 249.69 127.996 249.985",
    stroke: "#F98267",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M109.48 247.407C108.438 247.884 108.525 250.002 110.053 250.341C111.581 250.679 110.947 246.738 109.48 247.407Z",
    fill: "url(#paint77_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M134.643 239.542C133.115 240.688 130.658 240.983 128.592 240.913C124.712 240.792 120.319 243.526 116.882 244.742C115.015 245.401 113.513 245.341 112.541 245.15C112.558 244.464 112.602 243.9 112.784 243.752C113.314 243.309 121.309 239.932 122.689 237.267C123.974 239.845 124.512 239.976 125.485 239.663C126.457 239.351 131.483 235.574 132.1 233.439C132.377 236.347 133.801 238.5 134.634 239.542H134.643Z",
    fill: "url(#paint78_linear_47_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45,
    d: "M125.31 260.419C125.249 260.793 125.215 261.183 125.189 261.574C124.32 261.565 123.452 261.487 122.628 261.409C119.459 261.097 119.624 263.31 115.11 262.546C113.512 262.277 112.462 262.199 111.768 262.208C111.585 261.817 111.524 261.496 111.611 261.288C112.123 260.072 112.236 255.15 112.254 253.11C112.514 253.067 112.783 253.014 113.061 252.928C114.684 257.85 119.971 260.463 125.319 260.411L125.31 260.419Z",
    fill: "url(#paint79_linear_47_2)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M127.124 164.823L123.782 185.172L118.964 185.918L112.678 173.461L110.309 187.255L105.525 187.993L96.167 169.607L100.811 168.886L107.287 181.821L109.753 167.506L113.902 166.863L120.448 179.902L122.835 165.483L127.124 164.823Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M145.563 179.833L145.215 183.453L130.11 181.986L132.003 162.479L146.743 163.912L146.396 167.532L136.144 166.533L135.736 170.77L144.79 171.646L144.452 175.154L135.397 174.277L134.963 178.791L145.58 179.824L145.563 179.833Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M148.801 165.692L153.098 164.242L158.176 179.312L167.491 176.178L168.672 179.677L155.06 184.26L148.801 165.692Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M174.924 179.043C172.832 178.305 171.095 177.099 169.706 175.432C168.317 173.765 167.449 171.768 167.085 169.451C166.729 167.133 166.955 164.971 167.779 162.957C168.595 160.952 169.889 159.276 171.66 157.939C173.431 156.603 175.514 155.752 177.919 155.379C179.95 155.066 181.834 155.135 183.588 155.596C185.332 156.056 186.869 156.872 188.188 158.035L185.211 161.785C183.344 160.205 181.244 159.589 178.9 159.954C177.45 160.179 176.209 160.691 175.167 161.507C174.125 162.315 173.379 163.339 172.918 164.581C172.458 165.813 172.337 167.159 172.563 168.609C172.788 170.058 173.3 171.3 174.116 172.341C174.924 173.383 175.948 174.13 177.181 174.59C178.414 175.05 179.759 175.171 181.209 174.946C183.553 174.581 185.367 173.357 186.661 171.265L190.637 173.939C189.734 175.467 188.51 176.717 186.973 177.689C185.437 178.661 183.648 179.295 181.626 179.608C179.238 179.972 177.007 179.79 174.915 179.052L174.924 179.043Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M195.826 172.646C194.333 172.116 193.092 171.265 192.111 170.085C191.13 168.904 190.513 167.498 190.262 165.874C190.01 164.251 190.175 162.723 190.756 161.299C191.338 159.876 192.258 158.686 193.526 157.731C194.793 156.777 196.286 156.169 198.005 155.9C199.724 155.631 201.33 155.77 202.814 156.299C204.299 156.829 205.54 157.679 206.53 158.86C207.52 160.041 208.145 161.438 208.388 163.07C208.639 164.694 208.466 166.222 207.884 167.645C207.294 169.069 206.374 170.258 205.115 171.213C203.856 172.168 202.372 172.776 200.644 173.045C198.917 173.314 197.319 173.175 195.826 172.654V172.646ZM202.693 168.687C203.413 168.114 203.934 167.394 204.255 166.517C204.577 165.64 204.664 164.694 204.507 163.669C204.351 162.645 203.986 161.759 203.405 161.03C202.832 160.292 202.111 159.763 201.26 159.433C200.401 159.103 199.481 159.016 198.509 159.164C197.528 159.311 196.686 159.676 195.965 160.249C195.244 160.822 194.724 161.542 194.394 162.419C194.073 163.296 193.986 164.242 194.142 165.267C194.298 166.291 194.663 167.177 195.244 167.906C195.817 168.644 196.538 169.173 197.397 169.503C198.257 169.833 199.177 169.92 200.149 169.772C201.13 169.625 201.972 169.26 202.693 168.687Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M228.016 172.524L228.762 160.787L222.364 170.067L220.324 169.928L215.22 160.136L214.456 171.621L210.211 171.343L211.504 151.794L215.246 152.045L221.757 164.685L229.769 153.009L233.485 153.252L232.244 172.811L227.999 172.533L228.016 172.524Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M251.62 161.742L252.176 165.336L237.183 167.654L234.188 148.286L248.825 146.029L249.38 149.623L239.197 151.194L239.849 155.396L248.842 154.007L249.38 157.497L240.387 158.886L241.081 163.365L251.62 161.733V161.742Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_2",
    x1: 166.444,
    y1: 91.1125,
    x2: 252.725,
    y2: 341.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#214B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_2",
    x1: 135.886,
    y1: -754.112,
    x2: 239.729,
    y2: 568.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_2",
    x1: 13.4637,
    y1: 316.637,
    x2: 121.173,
    y2: 226.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47_2",
    x1: 12.0521,
    y1: 314.958,
    x2: 119.766,
    y2: 224.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_47_2",
    x1: 13.1738,
    y1: 316.281,
    x2: 120.884,
    y2: 225.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_47_2",
    x1: 28.4132,
    y1: 294.755,
    x2: 43.5558,
    y2: 230.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B77BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_47_2",
    x1: 39.0364,
    y1: 330.747,
    x2: 71.3441,
    y2: 193.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7D389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79F9BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_47_2",
    x1: 384.106,
    y1: 321.317,
    x2: 324.553,
    y2: 193.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_47_2",
    x1: 386.097,
    y1: 320.397,
    x2: 326.536,
    y2: 192.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_47_2",
    x1: 384.525,
    y1: 321.126,
    x2: 324.964,
    y2: 193.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_47_2",
    x1: 369.665,
    y1: 326.17,
    x2: 330.47,
    y2: 272.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B77BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_47_2",
    x1: 375.194,
    y1: 307.932,
    x2: 370.611,
    y2: 166.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7D389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79F9BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_47_2",
    x1: 207.339,
    y1: 180.944,
    x2: 218.451,
    y2: 212.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_47_2",
    x1: 306.121,
    y1: 402.624,
    x2: 255.215,
    y2: 221.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B77BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_47_2",
    x1: 273.865,
    y1: 263.492,
    x2: 273.214,
    y2: 261.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_47_2",
    x1: 280.289,
    y1: 263.492,
    x2: 279.638,
    y2: 261.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_47_2",
    x1: 286.717,
    y1: 263.492,
    x2: 286.066,
    y2: 261.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_47_2",
    x1: 273.865,
    y1: 268.848,
    x2: 273.214,
    y2: 266.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_47_2",
    x1: 280.289,
    y1: 268.848,
    x2: 279.638,
    y2: 266.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_47_2",
    x1: 286.717,
    y1: 268.848,
    x2: 286.066,
    y2: 266.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_47_2",
    x1: 273.865,
    y1: 274.204,
    x2: 273.214,
    y2: 272.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_47_2",
    x1: 280.289,
    y1: 274.204,
    x2: 279.638,
    y2: 272.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_47_2",
    x1: 286.717,
    y1: 274.204,
    x2: 286.066,
    y2: 272.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_47_2",
    x1: -17.8484,
    y1: 279.561,
    x2: -16.9802,
    y2: 277.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_47_2",
    x1: 280.289,
    y1: 279.561,
    x2: 279.638,
    y2: 277.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_47_2",
    x1: 286.717,
    y1: 279.561,
    x2: 286.066,
    y2: 277.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_47_2",
    x1: -17.8484,
    y1: 284.917,
    x2: -16.9803,
    y2: 282.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_47_2",
    x1: 280.289,
    y1: 284.917,
    x2: 279.638,
    y2: 282.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_47_2",
    x1: 286.717,
    y1: 284.917,
    x2: 286.066,
    y2: 282.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_47_2",
    x1: 273.865,
    y1: 290.282,
    x2: 273.214,
    y2: 288.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_47_2",
    x1: 280.289,
    y1: 290.282,
    x2: 279.638,
    y2: 288.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_47_2",
    x1: 286.717,
    y1: 290.282,
    x2: 286.066,
    y2: 288.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_47_2",
    x1: 267.18,
    y1: 301.958,
    x2: 266.529,
    y2: 299.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_47_2",
    x1: 273.605,
    y1: 301.958,
    x2: 272.954,
    y2: 299.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_47_2",
    x1: 280.036,
    y1: 301.958,
    x2: 279.385,
    y2: 299.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_47_2",
    x1: 267.18,
    y1: 307.314,
    x2: 266.529,
    y2: 305.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_47_2",
    x1: 273.605,
    y1: 307.314,
    x2: 272.954,
    y2: 305.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_47_2",
    x1: 280.036,
    y1: 307.314,
    x2: 279.385,
    y2: 305.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_47_2",
    x1: 267.18,
    y1: 312.671,
    x2: 266.529,
    y2: 310.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_47_2",
    x1: 273.605,
    y1: 312.671,
    x2: 272.954,
    y2: 310.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_47_2",
    x1: 280.036,
    y1: 312.67,
    x2: 279.385,
    y2: 310.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_47_2",
    x1: 267.18,
    y1: 318.026,
    x2: 266.529,
    y2: 316.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_47_2",
    x1: 273.605,
    y1: 318.026,
    x2: 272.954,
    y2: 316.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_47_2",
    x1: 280.036,
    y1: 318.026,
    x2: 279.385,
    y2: 316.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_47_2",
    x1: 267.18,
    y1: 323.382,
    x2: 266.529,
    y2: 321.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_47_2",
    x1: 273.605,
    y1: 323.382,
    x2: 272.954,
    y2: 321.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_47_2",
    x1: 280.036,
    y1: 323.382,
    x2: 279.385,
    y2: 321.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_47_2",
    x1: 267.18,
    y1: 328.748,
    x2: 266.529,
    y2: 326.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_47_2",
    x1: 273.605,
    y1: 328.748,
    x2: 272.954,
    y2: 326.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_47_2",
    x1: 280.036,
    y1: 328.747,
    x2: 279.385,
    y2: 326.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A1944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_47_2",
    x1: 260.988,
    y1: 211.787,
    x2: 289.41,
    y2: 302.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_47_2",
    x1: 254.124,
    y1: 236.763,
    x2: 287.165,
    y2: 215.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_47_2",
    x1: 266.935,
    y1: 264.864,
    x2: 275.104,
    y2: 226.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_47_2",
    x1: 347.592,
    y1: 439.094,
    x2: 219.311,
    y2: 222.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_47_2",
    x1: 392.142,
    y1: 412.738,
    x2: 263.861,
    y2: 195.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_47_2",
    x1: 256.689,
    y1: 233.03,
    x2: 271.022,
    y2: 296.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_47_2",
    x1: 280.887,
    y1: 227.552,
    x2: 295.22,
    y2: 290.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_47_2",
    x1: 220.132,
    y1: 183.635,
    x2: 220.132,
    y2: 199.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_47_2",
    x1: 280.152,
    y1: 139.344,
    x2: 292.41,
    y2: 168.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_47_2",
    x1: 219.38,
    y1: 174.077,
    x2: 219.259,
    y2: 226.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_47_2",
    x1: 270.729,
    y1: 140.429,
    x2: 304.959,
    y2: 184.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_47_2",
    x1: 392.298,
    y1: 299.909,
    x2: 224.935,
    y2: 295.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_47_2",
    x1: 384.344,
    y1: 263.952,
    x2: 268.269,
    y2: 275.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_47_2",
    x1: 275.407,
    y1: 220.564,
    x2: 268.653,
    y2: 260.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_47_2",
    x1: 285.063,
    y1: 224.028,
    x2: 269.167,
    y2: 246.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_47_2",
    x1: 271.971,
    y1: 196.326,
    x2: 262.908,
    y2: 247.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_47_2",
    x1: 219.195,
    y1: 237.716,
    x2: 218.223,
    y2: 243.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_47_2",
    x1: 258.29,
    y1: 237.483,
    x2: 233.089,
    y2: 355.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_47_2",
    x1: 142.197,
    y1: 262.095,
    x2: 100.797,
    y2: 225.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_47_2",
    x1: 117.398,
    y1: 389.056,
    x2: 112.814,
    y2: 267.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_47_2",
    x1: 208.909,
    y1: 255.307,
    x2: 182.371,
    y2: 280.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_47_2",
    x1: 12.2585,
    y1: 338.063,
    x2: 51.8183,
    y2: 321.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_47_2",
    x1: 128.472,
    y1: 273.493,
    x2: 107.273,
    y2: 247.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_47_2",
    x1: 61.8667,
    y1: 372.727,
    x2: 79.689,
    y2: 246.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B77BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_47_2",
    x1: 146.905,
    y1: 384.724,
    x2: 164.718,
    y2: 258.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B77BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_47_2",
    x1: 182.121,
    y1: 348.403,
    x2: 163.292,
    y2: 264.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_47_2",
    x1: 20.2951,
    y1: 330.866,
    x2: 120.024,
    y2: 325.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_47_2",
    x1: 105.843,
    y1: 236.217,
    x2: 116.113,
    y2: 268.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_47_2",
    x1: 120.111,
    y1: 229.237,
    x2: 127.238,
    y2: 256.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_47_2",
    x1: 119.129,
    y1: 246.165,
    x2: 117.862,
    y2: 273.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/Welcome.003f7ed0d95ce654280142ee2d2d15dc.svg";
export { ForwardRef as ReactComponent };